(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3176,3815,5512,3372,2982],{

/***/ 26693:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close-white.d3f1a0ed.svg","height":17,"width":17});

/***/ }),

/***/ 55619:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/modal-close.5d34d298.svg","height":29,"width":28});

/***/ }),

/***/ 36562:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/swatch-missing.457436f1.jpeg","height":368,"width":368,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAgACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAAsAP/xAAbEAAABwEAAAAAAAAAAAAAAAAAAQMREyRDgv/aAAgBAQABPwCwSucb9D//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAECAQE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDAQE/AH//2Q==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 97976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v2_PartsViewer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 20 modules
var Modal = __webpack_require__(88699);
;// CONCATENATED MODULE: ./hooks/useTrigger.js

const useTrigger = function() {
    let cap = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 3;
    const [value, setValue] = (0,react.useState)(0);
    const triggerAction = ()=>setValue((item)=>{
            return (item + 1) % cap + 1;
        });
    return [
        value,
        triggerAction
    ];
};
/* harmony default export */ var hooks_useTrigger = (useTrigger);

// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./services/ct.service.js
var ct_service = __webpack_require__(13875);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./utils/ProjectionPartlist.js


const getProjectionPartListData = async (partList)=>{
    try {
        var ref, ref1;
        const response = await (0,config/* getConfig */.i)();
        const currencyCode = response === null || response === void 0 ? void 0 : (ref = response.internationalization) === null || ref === void 0 ? void 0 : ref.currencyCode;
        const currencySign = response === null || response === void 0 ? void 0 : (ref1 = response.internationalization) === null || ref1 === void 0 ? void 0 : ref1.currencySign;
        const itemsCount = 20;
        let startFrom = 0;
        let endTo = itemsCount;
        const initialList = [];
        const groupArrayCount = Math.ceil(partList.length / itemsCount);
        const skus = partList.map((val)=>val.skuId);
        if ((partList === null || partList === void 0 ? void 0 : partList.length) <= itemsCount) {
            const resp = await (0,ct_service/* getProjectionData */.vP)({
                skus
            });
            return getPartsPricebySku(resp, currencyCode, currencySign);
        } else {
            const list = [];
            Array.from({
                length: groupArrayCount
            }, ()=>{
                list.push([
                    partList.slice(startFrom, endTo)
                ]);
                startFrom = endTo;
                endTo = endTo + itemsCount;
                return null;
            });
            list.forEach((val)=>{
                const skus = val[0].map((v)=>v.skuId);
                const resp = (0,ct_service/* getProjectionData */.vP)({
                    skus
                });
                initialList.push(resp);
            });
            const res = await Promise.allSettled(initialList);
            const combineItem = res.flatMap((x)=>x.value);
            return getPartsPricebySku(combineItem, currencyCode, currencySign);
        }
    } catch (err) {
        return err;
    }
};
const getPartsPricebySku = function(list) {
    let currencyCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "USD", currencySign = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "$";
    const sortItems = (i)=>{
        return {
            sku: i === null || i === void 0 ? void 0 : i.sku,
            currencySign,
            prices: i === null || i === void 0 ? void 0 : i.prices.filter((i)=>{
                var ref;
                return (i === null || i === void 0 ? void 0 : (ref = i.value) === null || ref === void 0 ? void 0 : ref.currencyCode) == currencyCode;
            }).reduce((a, i)=>{
                var ref, ref1;
                var ref2;
                return {
                    ...a,
                    [(ref2 = i === null || i === void 0 ? void 0 : (ref = i.customerGroup) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.key) !== null && ref2 !== void 0 ? ref2 : "ANY"]: i === null || i === void 0 ? void 0 : i.value
                };
            }, {})
        };
    };
    return list.reduce((acc, sku)=>{
        var ref;
        return {
            ...acc,
            [sku === null || sku === void 0 ? void 0 : (ref = sku.masterVariant) === null || ref === void 0 ? void 0 : ref.sku]: [
                ...sku.variants.map(sortItems),
                ...[
                    sku.masterVariant
                ].map(sortItems)
            ]
        };
    }, {});
};

;// CONCATENATED MODULE: ./hooks/useViewport.js

const useViewport = ()=>{
    const [device, setDevice] = (0,react.useState)(getValues);
    /**
   * This function does the comparisons for different viewports
   * @return {Object} Object of all the viewport flags
   */ function getValues() {
        const resolution = window.innerWidth;
        const isExtraSmallScreen = resolution <= 375;
        const isSmallScreen = resolution <= 812;
        const isMediumScreen = resolution > 812 && resolution <= 1024;
        const isLargeTabView = resolution > 1024;
        const isLargeScreen = resolution >= 1024 && resolution < 1920;
        const isExtraLargeScreen = resolution >= 1920;
        return {
            isExtraSmallScreen,
            isSmallScreen,
            isMediumScreen,
            isLargeScreen,
            isExtraLargeScreen,
            isLargeTabView
        };
    }
    /**
   * Sets updated viewport flag values
   */ function handleWindowResize() {
        setDevice(getValues());
    }
    (0,react.useEffect)(()=>{
        handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>{
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    return device;
};
/* harmony default export */ var hooks_useViewport = (useViewport);
const useViewportWidth = ()=>{
    const [width, setWidth] = (0,react.useState)(0);
    const handleWindowResize = ()=>setWidth(window.innerWidth);
    (0,react.useEffect)(()=>{
        handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>window.removeEventListener("resize", handleWindowResize);
    }, []);
    return width;
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/ErrorBoundary/index.js



/**
 * This will catch errors and show alternate view
 */ class ErrorBoundary extends react.Component {
    /**
   * Rejection.
   * @param {Error} error
   * @return {Object}
   */ static getDerivedStateFromError(error) {
        return {
            error: true,
            errorMessage: error.toString()
        };
    }
    /**
   * Adding listner function on mount to the event.
   */ componentDidMount() {
        window.addEventListener("unhandledrejection", this.promiseRejectionHandler);
    }
    /**
   * Remove listner function on unmount.
   */ componentWillUnmount() {
        window.removeEventListener("unhandledrejection", this.promiseRejectionHandler);
    }
    /**
   * @return {React.JSX} Return appropriate component
   */ render() {
        const { error , errorMessage  } = this.state;
        const { FallBackComponent , children , params  } = this.props;
        return error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FallBackComponent, {
            error,
            errorMessage,
            params
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                " ",
                children
            ]
        });
    }
    constructor(...args){
        super(...args);
        (0,_define_property/* default */.Z)(this, "state", {
            error: false,
            errorMessage: ""
        });
        /**
   * This function handles rejection.
   * @param {Event} event
   */ (0,_define_property/* default */.Z)(this, "promiseRejectionHandler", (event)=>{
            this.setState({
                error: event.reason
            }) // eslint-disable-line no-invalid-this
            ;
        });
    }
}
/* harmony default export */ var v2_ErrorBoundary = (ErrorBoundary);

// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/ErrorFallBack/index.js


const ErrorFallbackUI = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fallback-wrapper d-flex flex-column w-100 h-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "error-message",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line-first",
                        children: "Sorry, this diagram cannot be found"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "questions",
                        children: [
                            "If you have any questions please\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: constants.CONTACT_US_PAGE_URL_US,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "contact us"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ErrorFallBack = (ErrorFallbackUI);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/core/Coach/Coach.js



const Coach = (props)=>{
    const { text ="no text" , hide =false , showHeaderCoach =false , panelState , isOverlapping , displayKey =""  } = props;
    const [isShown, setIsShown] = (0,react.useState)(false);
    const [isSeen, setIsSeen] = (0,react.useState)(false);
    const device = hooks_useViewport();
    const [coachMarkPosition, setCoachMarkPosition] = (0,react.useState)({
        top: 0,
        left: 0,
        zIndex: 1
    });
    (0,react.useEffect)(()=>{
        updateCoachMarkPosition();
        window.addEventListener("resize", updateCoachMarkPosition);
        return ()=>{
            window.removeEventListener("resize", updateCoachMarkPosition);
        };
    }, [
        device
    ]);
    const updateCoachMarkPosition = ()=>{
        let top;
        let left;
        if (showHeaderCoach) {
            var ref, ref1, ref2;
            const addCoachFirstChild = (ref2 = (ref = document === null || document === void 0 ? void 0 : document.querySelector(".add-coach")) === null || ref === void 0 ? void 0 : (ref1 = ref.firstElementChild) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect()) === null || ref2 === void 0 ? void 0 : ref2.right;
            const contentChange = addCoachFirstChild - 85;
            if (device === null || device === void 0 ? void 0 : device.isExtraSmallScreen) {
                top = "110px";
                left = "65px";
            } else if (device === null || device === void 0 ? void 0 : device.isSmallScreen) {
                top = "115px";
                left = "85px";
            } else if (device === null || device === void 0 ? void 0 : device.isMediumScreen) {
                top = "110px";
                left = "".concat(contentChange, "px");
            } else {
                top = isOverlapping ? "115px" : "75px";
                left = "".concat(contentChange, "px");
            }
            setCoachMarkPosition({
                top: top,
                left: left
            });
        }
    };
    (0,react.useEffect)(()=>{
        if (!hide) setIsShown(true);
        else setIsShown(false);
    }, []);
    const conditionalCss = showHeaderCoach ? {
        top: coachMarkPosition.top,
        left: coachMarkPosition.left,
        zIndex: panelState ? 1 : 2
    } : null;
    (0,react.useEffect)(()=>{
        const getCoachKey = window.localStorage.getItem("getCoachKey");
        if (getCoachKey && JSON.parse(getCoachKey).hasOwnProperty(displayKey)) {
            setIsSeen(true);
        }
    }, []);
    const handlerModel = ()=>{
        const getCoachKeyVal = window.localStorage.getItem("getCoachKey");
        let keyVal = {};
        if (getCoachKeyVal) keyVal = JSON.parse(getCoachKeyVal);
        keyVal[displayKey] = "y";
        window.localStorage.setItem("getCoachKey", JSON.stringify(keyVal));
        setIsShown(false);
        setIsSeen(true);
    };
    return !isSeen && isShown && !hide ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "coach-mark",
        "data-testid": "header-back-button",
        style: conditionalCss,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "coach-text",
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "close-button-coach mx-2",
                onClick: handlerModel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.52079 11.3239L0.677734 10.4808L5.15773 6.0008L0.677734 1.52079L1.52079 0.677734L6.0008 5.15773L10.4808 0.677734L11.3239 1.52079L6.84386 6.0008L11.3239 10.4808L10.4808 11.3239L6.0008 6.84386L1.52079 11.3239Z",
                        fill: "#17181D"
                    })
                })
            })
        ]
    }) : null;
};
/* harmony default export */ var Coach_Coach = (Coach);

;// CONCATENATED MODULE: ./public/icons/cart-icon-dark-empty.svg
/* harmony default export */ var cart_icon_dark_empty = ({"src":"/_next/static/media/cart-icon-dark-empty.2d6bad3c.svg","height":23,"width":26});
;// CONCATENATED MODULE: ./public/icons/cart-icon-dark-nonempty.svg
/* harmony default export */ var cart_icon_dark_nonempty = ({"src":"/_next/static/media/cart-icon-dark-nonempty.63d9248c.svg","height":22,"width":25});
// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Shared/MiniCart/v2/MiniCart.jsx






const MiniCart = (param)=>{
    let { eventHandler: { store: { cartCount , ariaLabel  }  } , color ="dark"  } = param;
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,cart/* getCartLandingPagePath */.dZ)().then((res)=>{
            setCartUrl(res);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cart-indicator v2 ".concat(cartCount > 0 && "cart-indicator__with-count", " ").concat(color == "dark" ? "dark" : "light"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: cartUrl,
            "aria-label": ariaLabel,
            role: "link",
            className: "gbh-data-layer",
            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"'.concat(cartUrl, '","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"cart icon","eventName":"cart icon","internalLinkType":"homepage:navigation","eventType":"global header","eventAction":"cart icon"}'),
            children: cartCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cart-indicator__count ".concat(cartCount < 10 ? "count-single" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: cart_icon_dark_nonempty === null || cart_icon_dark_nonempty === void 0 ? void 0 : cart_icon_dark_nonempty.src,
                        alt: "Cart"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: cartCount
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: cart_icon_dark_empty === null || cart_icon_dark_empty === void 0 ? void 0 : cart_icon_dark_empty.src,
                alt: "Cart"
            })
        })
    });
};
const checkForRerender = (prevProps, nextProps)=>{
    return nextProps.eventHandler.store.cartCount === prevProps.eventHandler.store.cartCount;
};
/* harmony default export */ var v2_MiniCart = (/*#__PURE__*/(0,react.memo)(MiniCart, checkForRerender));

// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
;// CONCATENATED MODULE: ./public/scout_icon/icons/printIcon.svg
/* harmony default export */ var printIcon = ({"src":"/_next/static/media/printIcon.99057120.svg","height":30,"width":30});
;// CONCATENATED MODULE: ./public/scout_icon/icons/shareIcon.svg
/* harmony default export */ var shareIcon = ({"src":"/_next/static/media/shareIcon.773c9ce7.svg","height":30,"width":30});
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/SelectedFileView/FileSelection/index.js














const FileSelection = (props)=>{
    var ref;
    const { files , isActive , setSelected , setPopupModal , title , sku , skuImage , getFileTitle , setParts , panelState , initialIndex , setPartsHeight  } = props;
    const [visibleCoach, setVisibleCoach] = (0,react.useState)(false);
    const device = hooks_useViewport();
    const divRef = (0,react.useRef)(null);
    const tabRefs = (0,react.useRef)([]);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const cartCount = (0,cart/* getCartCount */.c0)();
    const ariaLabel = (0,cart/* getAriaLabel */.Xw)(t, cartCount);
    const { cartUrl  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [isOverlapping, setIsOverlapping] = (0,react.useState)(false);
    const featuresDtl = {
        displayClass: "d-inline",
        floating: (device === null || device === void 0 ? void 0 : device.isSmallScreen) || (device === null || device === void 0 ? void 0 : device.isMediumScreen) ? "" : "float-right",
        heightof: "h-80",
        skuDisplayClass: (device === null || device === void 0 ? void 0 : device.isSmallScreen) || (device === null || device === void 0 ? void 0 : device.isMediumScreen) ? "" : "d-inline"
    };
    const [features, setFeatures] = (0,react.useState)(featuresDtl);
    const router = (0,next_router.useRouter)();
    const redirect = ()=>{
        router.push("".concat(cartUrl));
    };
    const eventHandler = {
        store: {
            cartCount,
            ariaLabel,
            cartUrl
        },
        callbacks: {
            onClick: ()=>{
                redirect();
            }
        }
    };
    const scrollVisible = (index)=>{
        var ref, ref1, ref2;
        const addCoachContainer = document.querySelector(".add-coach");
        const offSetValue = ((ref1 = (ref = tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current[index]) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) === null || ref1 === void 0 ? void 0 : ref1.left) - ((ref2 = addCoachContainer === null || addCoachContainer === void 0 ? void 0 : addCoachContainer.getBoundingClientRect()) === null || ref2 === void 0 ? void 0 : ref2.left);
        if (tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current[index]) {
            var ref3;
            (ref3 = tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current[index]) === null || ref3 === void 0 ? void 0 : ref3.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "start"
            });
            if (!(device === null || device === void 0 ? void 0 : device.isSmallScreen)) {
                const timer = setTimeout(()=>addCoachContainer.scrollLeft += offSetValue, 100);
                return ()=>clearTimeout(timer);
            }
        }
    };
    const adjustSrcollForView = ()=>{
        const addCoachContainer = document.querySelector(".add-coach");
        const activeTabContent = document.querySelector(".activeTab");
        const addCoachContainerRect = addCoachContainer === null || addCoachContainer === void 0 ? void 0 : addCoachContainer.getBoundingClientRect();
        const activeTabContentRect = activeTabContent === null || activeTabContent === void 0 ? void 0 : activeTabContent.getBoundingClientRect();
        const offset = (activeTabContentRect === null || activeTabContentRect === void 0 ? void 0 : activeTabContentRect.left) - (addCoachContainerRect === null || addCoachContainerRect === void 0 ? void 0 : addCoachContainerRect.left);
        addCoachContainer.scrollLeft += offset;
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("resize", adjustSrcollForView);
        return ()=>{
            window.removeEventListener("resize", adjustSrcollForView);
        };
    }, []);
    (0,react.useEffect)(()=>{
        scrollVisible(initialIndex);
    }, [
        files,
        initialIndex
    ]);
    (0,react.useEffect)(()=>{
        setPartsHeight(features === null || features === void 0 ? void 0 : features.heightof);
        const timer = setTimeout(()=>setVisibleCoach(true), 3000);
        return ()=>clearTimeout(timer);
    }, []);
    const screenWidth = device.isLargeScreen || device.isExtraLargeScreen || device.isMediumScreen;
    const handlerFileSelection = async (e, item, index)=>{
        var ref;
        if (!(item === null || item === void 0 ? void 0 : item.prices) && (item === null || item === void 0 ? void 0 : (ref = item.Parts) === null || ref === void 0 ? void 0 : ref.length) !== 0) {
            const prices = await getProjectionPartListData(item === null || item === void 0 ? void 0 : item.Parts);
            setParts((prevState)=>{
                const { partsInfo: { SVGFiles  }  } = prevState;
                const updatePrice = SVGFiles === null || SVGFiles === void 0 ? void 0 : SVGFiles.filter((val)=>val.FileName === item.FileName);
                updatePrice[0].prices = prices;
                return {
                    ...prevState
                };
            });
        }
        setSelected(item);
        scrollVisible(index);
        setPopupModal(false);
    };
    (0,react.useEffect)(()=>{
        const checkOverlap = ()=>{
            if (device === null || device === void 0 ? void 0 : device.isLargeTabView) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                let addCoachSpan = 0;
                const childDiv = Array.from((ref = document === null || document === void 0 ? void 0 : document.querySelector(".add-coach")) === null || ref === void 0 ? void 0 : ref.children);
                childDiv.map((child)=>{
                    var ref;
                    return addCoachSpan += (ref = child === null || child === void 0 ? void 0 : child.getBoundingClientRect()) === null || ref === void 0 ? void 0 : ref.width;
                });
                if (((ref2 = (ref1 = document === null || document === void 0 ? void 0 : document.querySelector(".sku-title")) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect()) === null || ref2 === void 0 ? void 0 : ref2.width) + ((ref4 = (ref3 = document === null || document === void 0 ? void 0 : document.querySelector(".sku")) === null || ref3 === void 0 ? void 0 : ref3.getBoundingClientRect()) === null || ref4 === void 0 ? void 0 : ref4.width) + addCoachSpan + 200 > ((ref6 = (ref5 = document.querySelector(".section-title-file")) === null || ref5 === void 0 ? void 0 : ref5.getBoundingClientRect()) === null || ref6 === void 0 ? void 0 : ref6.width)) {
                    setIsOverlapping(true);
                } else {
                    setIsOverlapping(false);
                }
            }
        };
        checkOverlap();
        window.addEventListener("resize", checkOverlap);
        return ()=>window.removeEventListener("resize", checkOverlap);
    }, []);
    (0,react.useEffect)(()=>{
        if (isOverlapping) {
            setPartsHeight("h-115");
            setFeatures((prevfeatures)=>({
                    ...prevfeatures,
                    displayClass: "d-inline",
                    floating: "",
                    heightof: "h-115",
                    marginTb: "my-3",
                    skuDisplayClass: ""
                }));
        } else {
            setFeatures(featuresDtl);
            setPartsHeight("h-80");
        }
    }, [
        isOverlapping
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "check-modal d-flex flex-grow-1 ".concat(features.heightof),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-container modal_panel selection",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "only-image image-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "image-part",
                                src: skuImage,
                                alt: "skuimage"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "section-title-file ".concat(features.displayClass, " w-100"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "modal_header flex-item ".concat(features.displayClass),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "sku-part ".concat(features.skuDisplayClass),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sku-title",
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sku",
                                                children: sku
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex-container header-content ".concat(features.floating),
                                    children: [
                                        files.length !== 1 && visibleCoach ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Coach_Coach, {
                                            text: "",
                                            show: true,
                                            showHeaderCoach: true,
                                            panelState: panelState,
                                            isOverlapping: isOverlapping,
                                            displayKey: "top"
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            ref: divRef,
                                            className: "add-coach",
                                            children: (ref = files === null || files === void 0 ? void 0 : files.filter((files)=>"FileName" in files)) === null || ref === void 0 ? void 0 : ref.map((item, index)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    ref: (el)=>tabRefs.current[index] = el,
                                                    className: "file-tab user-select-none  header-icons header-name" + (isActive(item) ? " activeTab" : ""),
                                                    onClick: (e)=>{
                                                        handlerFileSelection(e, item, index);
                                                    },
                                                    onKeyDown: (val)=>val,
                                                    children: getFileTitle(item === null || item === void 0 ? void 0 : item.FileName)
                                                }, "".concat(index + (item === null || item === void 0 ? void 0 : item.FileName)));
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(!(device.isMediumScreen || device.isSmallScreen) ? "mr-50" : ""),
                    children: screenWidth ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "print-share-div d-flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "header-img d-flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: printIcon === null || printIcon === void 0 ? void 0 : printIcon.src,
                                    alt: "print"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: shareIcon === null || shareIcon === void 0 ? void 0 : shareIcon.src,
                                    alt: "share"
                                })
                            ]
                        })
                    }) : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "parts-cart-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_MiniCart, {
                        eventHandler: eventHandler,
                        source: "from desk"
                    })
                })
            ]
        })
    });
};
FileSelection.propTypes = {
    files: (prop_types_default()).array
};
/* harmony default export */ var SelectedFileView_FileSelection = (FileSelection);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/partReducer.js



const partsReducer = (state, action)=>{
    try {
        switch(action.type){
            case "initPartsList":
                {
                    const newParts = action.payload.Parts.map((item)=>{
                        var ref, ref1;
                        return {
                            key: item === null || item === void 0 ? void 0 : item.Cod,
                            partApi: item,
                            ctApiPromise: null,
                            prices: (action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : ref.prices) ? action === null || action === void 0 ? void 0 : (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.prices[item === null || item === void 0 ? void 0 : item.skuId] : 0
                        };
                    });
                    state.parts = newParts;
                    const sortAsc = sortByName(state, "asc");
                    return {
                        parts: sortAsc
                    };
                }
            case "fetchCT":
                {
                    const { payload  } = action;
                    const newParts1 = state.parts.map((item)=>{
                        if (payload.includes(item.key) && item.ctApiPromise == null) return {
                            ...item,
                            ctApiPromise: fetchCTRequest(item.partApi, item === null || item === void 0 ? void 0 : item.prices)
                        };
                        return item;
                    });
                    return {
                        parts: newParts1
                    };
                }
            case "fetchCTAny":
                {
                    const { payload: payload1  } = action;
                    const newParts2 = [];
                    let count = 0;
                    for (const item of state.parts){
                        if (item.ctApiPromise == null && count < payload1) {
                            newParts2.push({
                                ...item,
                                ctApiPromise: fetchCTRequest(item.partApi, item === null || item === void 0 ? void 0 : item.prices)
                            });
                            count++;
                        } else newParts2.push(item);
                    }
                    return {
                        parts: newParts2
                    };
                }
            case "filterProduct":
                {
                    const { payload: payload2  } = action;
                    const persona = (0,helper.getUserPersona)();
                    let sortedData;
                    switch(payload2){
                        case "asc":
                            sortedData = sortByName(state, "asc");
                            break;
                        case "desc":
                            sortedData = sortByName(state, "desc");
                            break;
                        case "descPrice":
                            sortedData = sortByPriceDesc(state, persona);
                            break;
                        case "ascPrice":
                            sortedData = sortByPrice(state, persona, "asc");
                            break;
                    }
                    return {
                        parts: sortedData
                    };
                }
            case "fetchForCpiPromise":
                {
                    const { payload: payload3  } = action;
                    const newParts3 = [];
                    let arraylength = 0;
                    for (const item1 of state.parts){
                        arraylength = newParts3 === null || newParts3 === void 0 ? void 0 : newParts3.length;
                        if (item1.ctApiPromise == null && arraylength < payload3) {
                            newParts3.push({
                                ...item1,
                                ctApiPromise: fetchCTRequest(item1.partApi, item1 === null || item1 === void 0 ? void 0 : item1.prices)
                            });
                        } else newParts3.push(item1);
                    }
                    return {
                        parts: newParts3
                    };
                }
            default:
                throw new Error("default");
        }
    } catch (e) {
        return e;
    }
};
/* harmony default export */ var partReducer = (partsReducer);
const sortByName = (state, order)=>{
    switch(order){
        case "desc":
            return state.parts.sort((a, b)=>{
                var ref, ref1, ref2, ref3;
                if ((a === null || a === void 0 ? void 0 : (ref = a.partApi) === null || ref === void 0 ? void 0 : ref.Name) < (b === null || b === void 0 ? void 0 : (ref1 = b.partApi) === null || ref1 === void 0 ? void 0 : ref1.Name)) return 1;
                if ((a === null || a === void 0 ? void 0 : (ref2 = a.partApi) === null || ref2 === void 0 ? void 0 : ref2.Name) > (b === null || b === void 0 ? void 0 : (ref3 = b.partApi) === null || ref3 === void 0 ? void 0 : ref3.Name)) return -1;
                return 0;
            });
        case "asc":
            return state.parts.sort((a, b)=>{
                var ref, ref1, ref2, ref3;
                if (((ref = a.partApi) === null || ref === void 0 ? void 0 : ref.Name) > ((ref1 = b.partApi) === null || ref1 === void 0 ? void 0 : ref1.Name)) return 1;
                if (((ref2 = a.partApi) === null || ref2 === void 0 ? void 0 : ref2.Name) < ((ref3 = b.partApi) === null || ref3 === void 0 ? void 0 : ref3.Name)) return -1;
                return 0;
            });
    }
};
const sortByPrice = function(state, persona) {
    let order = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "asc";
    state.parts.map((part)=>{
        return {
            ...part,
            prices: part.prices.sort((a, b)=>{
                var ref, ref1;
                return ((ref = a === null || a === void 0 ? void 0 : a.prices[persona]) === null || ref === void 0 ? void 0 : ref.centAmount) - ((ref1 = b === null || b === void 0 ? void 0 : b.prices[persona]) === null || ref1 === void 0 ? void 0 : ref1.centAmount);
            })
        };
    });
    const sortingPrice = personaPriceSort(persona);
    return state.parts.sort((a, b)=>a.partApi[sortingPrice] - b.partApi[sortingPrice]);
};
const sortByPriceDesc = (state, persona)=>{
    state.parts.map((part)=>{
        return {
            ...part,
            prices: part.prices.sort((a, b)=>{
                var ref, ref1;
                return ((ref = b === null || b === void 0 ? void 0 : b.prices[persona]) === null || ref === void 0 ? void 0 : ref.centAmount) - ((ref1 = a === null || a === void 0 ? void 0 : a.prices[persona]) === null || ref1 === void 0 ? void 0 : ref1.centAmount);
            })
        };
    });
    const sortingPrice = personaPriceSort(persona);
    return state.parts.sort((a, b)=>b.partApi[sortingPrice] - a.partApi[sortingPrice]);
};
const getActions = (state, dispatch)=>{
    return {
        initPartsList: (payload)=>dispatch({
                type: "initPartsList",
                payload
            }),
        fetchCT: (payload)=>dispatch({
                type: "fetchCT",
                payload
            }),
        fetchCTAny: (payload)=>dispatch({
                type: "fetchCTAny",
                payload
            }),
        filterProduct: (payload)=>dispatch({
                type: "filterProduct",
                payload
            }),
        fetchForCpiPromise: (payload)=>dispatch({
                type: "fetchForCpiPromise",
                payload
            }),
        get: {
            readyEntries: ()=>{
                return state === null || state === void 0 ? void 0 : state.parts.filter((item)=>{
                    return (item === null || item === void 0 ? void 0 : item.ctApiPromise) != null;
                });
            },
            firstEntries: (key)=>{
                var ref;
                return (ref = state === null || state === void 0 ? void 0 : state.parts.filter((item)=>{
                    return (item === null || item === void 0 ? void 0 : item.ctApiPromise) != null;
                })) === null || ref === void 0 ? void 0 : ref.splice(0, key);
            },
            entryByKey: (key)=>{
                var ref;
                const data = (ref = state === null || state === void 0 ? void 0 : state.parts.filter((item)=>{
                    return (item === null || item === void 0 ? void 0 : item.key) == key;
                })) === null || ref === void 0 ? void 0 : ref[0];
                if ((data === null || data === void 0 ? void 0 : data.ctApiPromise) === null) {
                    return {
                        ...data,
                        ctApiPromise: fetchCTRequest(data === null || data === void 0 ? void 0 : data.partApi, data === null || data === void 0 ? void 0 : data.prices)
                    };
                }
                return data;
            }
        }
    };
};
const fetchCTRequest = async (args, prices)=>{
    try {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
        const docs = await getSearchDetails(args, prices);
        const data = {
            ...args,
            productDiscontinue: Date.parse((ref = docs[0]) === null || ref === void 0 ? void 0 : ref.productDiscontinuedDate_dt) < Date.now(),
            productIdKey: (docs === null || docs === void 0 ? void 0 : (ref1 = docs[0]) === null || ref1 === void 0 ? void 0 : ref1["ProductNoSpecialKeyword"]) ? docs === null || docs === void 0 ? void 0 : (ref2 = docs[0]) === null || ref2 === void 0 ? void 0 : ref2["ProductNoSpecialKeyword"] : docs === null || docs === void 0 ? void 0 : (ref3 = docs[0]) === null || ref3 === void 0 ? void 0 : ref3["CustomerFacingSKU_s"],
            imageUrl: ((ref7 = docs === null || docs === void 0 ? void 0 : (ref4 = docs[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4["Color.KEMP.Details_ss"]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.split("||")) === null || ref7 === void 0 ? void 0 : ref7[1]) ? (ref8 = docs[0]["Color.KEMP.Details_ss"][0]) === null || ref8 === void 0 ? void 0 : ref8.split("||")[1] : null,
            activeItem: (ref12 = docs === null || docs === void 0 ? void 0 : (ref9 = docs[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9["Color.KEMP.Details_ss"]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.split("||")[0]) === null || ref12 === void 0 ? void 0 : ref12.split("|")[0],
            data: docs[0]
        };
        return data;
    } catch (err) {
        return err;
    }
};
const getSearchDetails = async (args, prices)=>{
    const { slug  } = args;
    const resp = await (0,ct_service/* getSearchPDP */.Do)(slug);
    const persona = (0,helper.getUserPersona)();
    const { data: { response: { docs  }  }  } = resp;
    if (docs.length != 0) {
        var ref, ref1;
        docs[0].prices = prices;
        const varientDetails = getVarientDetails(docs[0]);
        const fieldType = (ref = varientDetails[0]) === null || ref === void 0 ? void 0 : ref.fieldType;
        const swatches = (ref1 = docs[0][fieldType]) === null || ref1 === void 0 ? void 0 : ref1.map((val, i)=>{
            var ref, ref1, ref2, ref3, ref4;
            let price = 0;
            let pricelist = 0;
            let currencyCode = "USD";
            let currencySign = "$";
            const [label, swatch, id, , , value] = val.split("|");
            const sortPrice = (ref = docs[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.prices) === null || ref1 === void 0 ? void 0 : ref1.filter((val)=>{
                return (val === null || val === void 0 ? void 0 : val.sku) === id;
            })[0];
            currencyCode = (ref2 = sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.prices[persona]) === null || ref2 === void 0 ? void 0 : ref2.currencyCode;
            currencySign = sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.currencySign;
            var ref5;
            const centPrice = (ref5 = (ref3 = sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.prices[persona]) === null || ref3 === void 0 ? void 0 : ref3.centAmount) !== null && ref5 !== void 0 ? ref5 : 0;
            var ref6;
            pricelist = Number(((ref6 = (ref4 = sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.prices["ANY"]) === null || ref4 === void 0 ? void 0 : ref4.centAmount) !== null && ref6 !== void 0 ? ref6 : 0) / 100).toFixed(2);
            price = Number(centPrice / 100).toFixed(2);
            const colorBaseUrl = constants["default"].COLOR_FILE_URL;
            const colorUrl = colorBaseUrl + swatch;
            const imgUrl = docs[0]["productImages.url_ss"] ? docs[0]["productImages.url_ss"][0] : null;
            return {
                checked: false,
                colorUrl,
                discontinuedColor: false,
                id,
                label,
                name: "product-color",
                notApplicable: false,
                value,
                price,
                pricelist,
                currencyCode,
                currencySign,
                imgUrl,
                centPrice
            };
        });
        docs[0].colorData = swatches;
        docs[0].varientDetails = varientDetails;
        return docs;
    } else return docs;
};
const getVarientDetails = (data)=>{
    if (data["Color.SKU.Details_ss"]) {
        return data["Color.SKU.Details_ss"].map((color)=>{
            const d = color.split("|");
            return {
                name: d[0],
                swatch: d[1],
                sku: d[2],
                isStock: d[3],
                discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now()),
                customerSku: d[5],
                fieldType: "Color.SKU.Details_ss"
            };
        });
    } else if (data["Color.SKU.Details_s"]) {
        const d = data["Color.SKU.Details_s"].split("|");
        return [
            {
                name: d[0],
                swatch: d[1],
                sku: d[2],
                isStock: d[3],
                discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now()),
                customerSku: d[5],
                fieldType: "Color.SKU.Details_s"
            }
        ];
    } else if (data["SKU.Details_ss"]) {
        return data["SKU.Details_ss"].map((color)=>{
            const d = color.split("|");
            return {
                name: "Not Applicable",
                swatch: "swatch_NA",
                sku: d[0],
                isStock: d[1],
                discontinued: !(d[2] === "false" || Date.parse(d[2]) > Date.now()),
                customerSku: d[3],
                fieldType: "SKU.Details_ss"
            };
        });
    }
};
const personaPriceSort = (persona)=>{
    switch(persona){
        case "GST":
            return "guestPrice";
        case "CTR":
            return "ctrPrice";
        case "FF":
            return "ffPrice";
        case "KEMP":
            return "kemprPrice";
        case "TPR":
            return "tprPrice";
        case "TVR":
            return "tvrPrice";
        default:
            return "guestPrice";
    }
};

// EXTERNAL MODULE: ./node_modules/react-zoom-pan-pinch/dist/index.esm.js
var index_esm = __webpack_require__(26126);
;// CONCATENATED MODULE: ./public/images/spinner.svg
/* harmony default export */ var spinner = ({"src":"/_next/static/media/spinner.3693c331.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./components/PartsViewer/v2/icon.js



const IconReset = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.5625 26.25V24.625C11.9583 24.3958 9.83333 23.4583 8.1875 21.8125C6.54167 20.1667 5.60417 18.0417 5.375 15.4375H3.75V14.5625H5.375C5.60417 11.9583 6.54167 9.83333 8.1875 8.1875C9.83333 6.54167 11.9583 5.60417 14.5625 5.375V3.75H15.4375V5.375C18.0417 5.60417 20.1667 6.54167 21.8125 8.1875C23.4583 9.83333 24.3958 11.9583 24.625 14.5625H26.25V15.4375H24.625C24.3958 18.0417 23.4583 20.1667 21.8125 21.8125C20.1667 23.4583 18.0417 24.3958 15.4375 24.625V26.25H14.5625ZM15 23.75C17.4167 23.75 19.4792 22.8958 21.1875 21.1875C22.8958 19.4792 23.75 17.4167 23.75 15C23.75 12.5833 22.8958 10.5208 21.1875 8.8125C19.4792 7.10417 17.4167 6.25 15 6.25C12.5833 6.25 10.5208 7.10417 8.8125 8.8125C7.10417 10.5208 6.25 12.5833 6.25 15C6.25 17.4167 7.10417 19.4792 8.8125 21.1875C10.5208 22.8958 12.5833 23.75 15 23.75ZM15 18.375C14.0719 18.375 13.2773 18.0445 12.6164 17.3836C11.9555 16.7227 11.625 15.9281 11.625 15C11.625 14.0719 11.9555 13.2773 12.6164 12.6164C13.2773 11.9555 14.0719 11.625 15 11.625C15.9281 11.625 16.7227 11.9555 17.3836 12.6164C18.0445 13.2773 18.375 14.0719 18.375 15C18.375 15.9281 18.0445 16.7227 17.3836 17.3836C16.7227 18.0445 15.9281 18.375 15 18.375Z",
            fill: "#ffffff"
        })
    });
const IconZoomIn = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.5 15.5V25H15.5V15.5H25V14.5H15.5V5H14.5V14.5H5V15.5H14.5Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.5 15.5V25H15.5V15.5H25V14.5H15.5V5H14.5V14.5H5V15.5H14.5Z",
                fill: "#ffffff"
            })
        ]
    });
const IconZoomOut = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 14.5H25V15.5H5V14.5Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 14.5H25V15.5H5V14.5Z",
                fill: "#ffffff"
            })
        ]
    });
const IconExpand = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.6985 16.2919L13.4056 16.999L8.46951 21.9341L12.7302 21.9341V22.9341H6.7793L6.7793 16.9832H7.7793L7.77937 21.2101L12.6985 16.2919ZM22.3215 6.76526V12.7162H21.3215L21.3203 8.48826L16.1524 13.6575L15.4453 12.9504L20.6303 7.76426L16.3706 7.76526V6.76526H22.3215Z",
            fill: "#ffffff"
        })
    });
const IconExpandGrid = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M5.91917 10.2918L6.62628 10.9989L1.69021 15.934L5.95093 15.934V16.934H0L0 10.9831H1L1.00007 15.2099L5.91917 10.2918ZM15.5422 0.765137V6.71606H14.5422L14.541 2.48814L9.37307 7.65737L8.66596 6.95027L13.851 1.76414L9.59131 1.76514V0.765137H15.5422Z",
            fill: "#212121"
        })
    });
const IconCollapse = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.35338 17.4951L0.586914 16.7291L6.23617 11.0833H2.49991V10H8.0866V15.5833H7.00263V11.8493L1.35338 17.4951Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.0879 7.99515V2.41183H11.1719V6.14583L16.8211 0.5L17.5876 1.266L11.9383 6.91183H15.6746V7.99515H10.0879Z",
                fill: "#ffffff"
            })
        ]
    });
const ResetActive = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.5625 26.25V24.625C11.9583 24.3958 9.83333 23.4583 8.1875 21.8125C6.54167 20.1667 5.60417 18.0417 5.375 15.4375H3.75V14.5625H5.375C5.60417 11.9583 6.54167 9.83333 8.1875 8.1875C9.83333 6.54167 11.9583 5.60417 14.5625 5.375V3.75H15.4375V5.375C18.0417 5.60417 20.1667 6.54167 21.8125 8.1875C23.4583 9.83333 24.3958 11.9583 24.625 14.5625H26.25V15.4375H24.625C24.3958 18.0417 23.4583 20.1667 21.8125 21.8125C20.1667 23.4583 18.0417 24.3958 15.4375 24.625V26.25H14.5625ZM15 23.75C17.4167 23.75 19.4792 22.8958 21.1875 21.1875C22.8958 19.4792 23.75 17.4167 23.75 15C23.75 12.5833 22.8958 10.5208 21.1875 8.8125C19.4792 7.10417 17.4167 6.25 15 6.25C12.5833 6.25 10.5208 7.10417 8.8125 8.8125C7.10417 10.5208 6.25 12.5833 6.25 15C6.25 17.4167 7.10417 19.4792 8.8125 21.1875C10.5208 22.8958 12.5833 23.75 15 23.75ZM15 18.375C14.0719 18.375 13.2773 18.0445 12.6164 17.3836C11.9555 16.7227 11.625 15.9281 11.625 15C11.625 14.0719 11.9555 13.2773 12.6164 12.6164C13.2773 11.9555 14.0719 11.625 15 11.625C15.9281 11.625 16.7227 11.9555 17.3836 12.6164C18.0445 13.2773 18.375 14.0719 18.375 15C18.375 15.9281 18.0445 16.7227 17.3836 17.3836C16.7227 18.0445 15.9281 18.375 15 18.375ZM15 17.5C15.6875 17.5 16.276 17.2552 16.7656 16.7656C17.2552 16.276 17.5 15.6875 17.5 15C17.5 14.3125 17.2552 13.724 16.7656 13.2344C16.276 12.7448 15.6875 12.5 15 12.5C14.3125 12.5 13.724 12.7448 13.2344 13.2344C12.7448 13.724 12.5 14.3125 12.5 15C12.5 15.6875 12.7448 16.276 13.2344 16.7656C13.724 17.2552 14.3125 17.5 15 17.5Z",
            fill: "#00BCE5"
        })
    });
const LoadingImage = ()=>/*#__PURE__*/ _jsx("div", {
        className: "loading-spinner",
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "56",
            height: "56",
            viewBox: "0 0 60 60",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("circle", {
                    cx: "30",
                    cy: "30",
                    r: "28",
                    stroke: "url(#paint0_linear_952_180)",
                    strokeWidth: "4"
                }),
                /*#__PURE__*/ _jsx("defs", {
                    children: /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_952_180",
                        x1: "54.1411",
                        y1: "49.3794",
                        x2: "9.49243",
                        y2: "8.51453",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#1AAA89"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.237209",
                                stopColor: "#08A1A9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.508047",
                                stopColor: "#1E80B7"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.784094",
                                stopColor: "#693A92"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#D81081"
                            })
                        ]
                    })
                })
            ]
        })
    });
const CloseIcon = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.76087 8.49989L0 15.9245L0.73913 16.6316L8.5 9.207L16.2609 16.6316L17 15.9245L9.23913 8.49989L17 1.07527L16.2609 0.368164L8.5 7.79278L0.739131 0.368164L0 1.07527L7.76087 8.49989Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.76087 8.49989L0 15.9245L0.73913 16.6316L8.5 9.207L16.2609 16.6316L17 15.9245L9.23913 8.49989L17 1.07527L16.2609 0.368164L8.5 7.79278L0.739131 0.368164L0 1.07527L7.76087 8.49989Z",
                fill: "#212121"
            })
        ]
    });
};
const DownIcon = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "10",
        viewBox: "0 0 16 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M15.1504 0L15.8799 0.683941L8.01516 9.07303L0.150391 0.683941L0.879928 0L8.01516 7.61097L15.1504 0Z",
                fill: "#757575"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M15.1504 0L15.8799 0.683941L8.01516 9.07303L0.150391 0.683941L0.879928 0L8.01516 7.61097L15.1504 0Z",
                fill: "#212121"
            })
        ]
    });
};
const PlusIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M6.25 13.75V7.74995H0.25V6.25H6.25V0.25H7.74995V6.25H13.75V7.74995H7.74995V13.75H6.25Z",
            fill: "#757575"
        })
    });
const MinusIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "2",
        viewBox: "0 0 14 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M0.25 1.74995V0.25H13.75V1.74995H0.25Z",
            fill: "#CCCCCC"
        })
    });
const SortIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "18",
        height: "13",
        viewBox: "0 0 18 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M7.23755 12.703V11.203H10.7375V12.703H7.23755ZM3.23755 7.51064V6.01068H14.7375V7.51064H3.23755ZM0.237549 2.31833V0.818359H17.7375V2.31833H0.237549Z",
            fill: "#1C1B1F"
        })
    });
const SortByIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "21",
        height: "30",
        viewBox: "0 0 21 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M15.5 12.5025C14.2917 12.5309 13.2375 11.6876 13 10.5025H0V9.50251H13C13.2366 8.33734 14.2611 7.5 15.45 7.5C16.6389 7.5 17.6634 8.33734 17.9 9.50251H21V10.5025H17.95C17.7159 11.6688 16.6896 12.5067 15.5 12.5025ZM15.5 8.50293C14.6716 8.50293 14 9.1745 14 10.0029C14 10.8314 14.6716 11.5029 15.5 11.5029C16.3284 11.5029 17 10.8314 17 10.0029C17 9.1745 16.3284 8.50293 15.5 8.50293Z",
                fill: "#494949"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M3 19.5278C3.2264 18.3507 4.25636 17.5 5.455 17.5C6.65364 17.5 7.6836 18.3507 7.91 19.5278H21V20.5278H7.95C7.75555 21.7579 6.68544 22.6572 5.44026 22.6371C4.19509 22.617 3.15459 21.6835 3 20.4478H0V19.4478L3 19.5278ZM5.45996 21.5273C6.28839 21.5273 6.95996 20.8558 6.95996 20.0273C6.95996 19.1989 6.28839 18.5273 5.45996 18.5273C4.63153 18.5273 3.95996 19.1989 3.95996 20.0273C3.96517 20.4287 4.13103 20.8113 4.42045 21.0894C4.70987 21.3675 5.0987 21.5181 5.49996 21.5073L5.45996 21.5273Z",
                fill: "#494949"
            })
        ]
    });
const ImageThumbIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M-0.000244141 6.20115V0.201172H5.99974V6.20115H-0.000244141ZM-0.000244141 13.8011V7.80115H5.99974V13.8011H-0.000244141ZM7.59974 6.20115V0.201172H13.5997V6.20115H7.59974ZM7.59974 13.8011V7.80115H13.5997V13.8011H7.59974Z",
            fill: "#757575"
        })
    });
const ImageListIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M0.000244141 11.4015V10.2016H14.0002V11.4015H0.000244141ZM0.000244141 8.20152V7.00156H14.0002V8.20152H0.000244141ZM0.000244141 5.00152V3.80156H14.0002V5.00152H0.000244141ZM0.000244141 1.80152V0.601562H14.0002V1.80152H0.000244141Z",
            fill: "#757575"
        })
    });
const CrossButton = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M1.5 1.5L14.5 14.5",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 1.5L1.5 14.5",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        ]
    });
const ModalCloseIcon = ()=>{
    return /*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1.40002 13.6553L0.346191 12.6015L5.94619 7.00148L0.346191 1.40148L1.40002 0.347656L7.00002 5.94766L12.6 0.347656L13.6538 1.40148L8.05384 7.00148L13.6538 12.6015L12.6 13.6553L7.00002 8.05531L1.40002 13.6553Z",
            fill: "#757575"
        })
    });
};
const ExitFullScreenIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M40 25C48.2843 25 55 31.7157 55 40C55 48.2843 48.2843 55 40 55C31.7157 55 25 48.2843 25 40C25 31.7157 31.7157 25 40 25Z",
            stroke: "#3FC28F",
            "stroke-width": "4",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    });
const IconApiError = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        className: "icon-api-error",
        viewBox: "0 0 168 169",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.999695 75.6734C0.999695 116.914 34.4321 150.347 75.6731 150.347C116.914 150.347 150.347 116.914 150.347 75.6734C150.347 34.4324 116.914 1 75.6731 1C34.4321 1 0.999695 34.4324 0.999695 75.6734ZM-0.000305176 75.6734C-0.000305176 117.467 33.8798 151.347 75.6731 151.347C96.8809 151.347 116.051 142.623 129.791 128.567L166.603 168.287L167.337 167.607L130.486 127.847C143.412 114.271 151.347 95.8987 151.347 75.6734C151.347 33.8801 117.466 0 75.6731 0C33.8798 0 -0.000305176 33.8801 -0.000305176 75.6734ZM61.0059 59.2387C61.2988 58.9458 61.7737 58.9458 62.0666 59.2387L77.8234 74.9955L93.5802 59.2387C93.8731 58.9458 94.3479 58.9458 94.6408 59.2387C94.9337 59.5316 94.9337 60.0065 94.6408 60.2994L78.884 76.0562L94.6407 91.8129C94.9336 92.1058 94.9336 92.5806 94.6407 92.8735C94.3478 93.1664 93.873 93.1664 93.5801 92.8735L77.8234 77.1168L62.0667 92.8735C61.7738 93.1664 61.2989 93.1664 61.006 92.8735C60.7131 92.5806 60.7131 92.1058 61.006 91.8129L76.7627 76.0562L61.0059 60.2994C60.713 60.0065 60.713 59.5316 61.0059 59.2387Z",
                fill: "url(#paint0_linear_2074_15327)"
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("linearGradient", {
                    id: "paint0_linear_2074_15327",
                    x1: "0.223115",
                    y1: "0",
                    x2: "167.337",
                    y2: "0",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#1AAA89"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.237209",
                            stopColor: "#08A1A9"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.508047",
                            stopColor: "#1E80B7"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.784094",
                            stopColor: "#693A92"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "1",
                            stopColor: "#D81081"
                        })
                    ]
                })
            })
        ]
    });
};
const ImageGridViewMobile = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "grid icons/grid filled",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Path",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7 6H0V13H7V6Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17 6H10V13H17V6Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0 16H7V23H0V16Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17 16H10V23H17V16Z",
                        fill: "#212121"
                    })
                ]
            })
        })
    });
const ImageListViewMobile = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "grid icons/vertical empty",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Path",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M-1.74846e-07 10L17 10L17 6L0 6L-1.74846e-07 10ZM16 7L16 9L1 9L1 7L16 7Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M-7.43094e-07 23L17 23L17 19L-5.68248e-07 19L-7.43094e-07 23ZM16 20L16 22L0.999999 22L0.999999 20L16 20Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17 16.5L-4.5897e-07 16.5L-2.84124e-07 12.5L8.5 12.5L17 12.5L17 16.5ZM16 15.5L16 13.5L1 13.5L1 15.5L16 15.5Z",
                        fill: "#212121"
                    })
                ]
            })
        })
    });
const SortByDropDownIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "13",
        height: "30",
        viewBox: "0 0 13 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M12.1814 11L13 11.6448L6.5 18.8179L0 11.6448L0.782276 11L6.5 17.2061L12.1814 11Z",
                fill: "#757575"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M12.1814 11L13 11.6448L6.5 18.8179L0 11.6448L0.782276 11L6.5 17.2061L12.1814 11Z",
                fill: "#494949"
            })
        ]
    });
const IconClose = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.7609 15.4999L7 22.9245L7.73913 23.6316L15.5 16.207L23.2609 23.6316L24 22.9245L16.2391 15.4999L24 8.07527L23.2609 7.36816L15.5 14.7928L7.73913 7.36816L7 8.07527L14.7609 15.4999Z",
                fill: "#757575"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.7609 15.4999L7 22.9245L7.73913 23.6316L15.5 16.207L23.2609 23.6316L24 22.9245L16.2391 15.4999L24 8.07527L23.2609 7.36816L15.5 14.7928L7.73913 7.36816L7 8.07527L14.7609 15.4999Z",
                fill: "#757575"
            })
        ]
    });
const IncIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "14",
        height: "30",
        viewBox: "0 0 14 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.5 15.4995V21.9995H7.5V15.4995H14V14.4995H7.5V7.99951H6.5V14.4995H0V15.4995H6.5Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.5 15.4995V21.9995H7.5V15.4995H14V14.4995H7.5V7.99951H6.5V14.4995H0V15.4995H6.5Z",
                fill: "#212121"
            })
        ]
    });
const DecIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "14",
        height: "30",
        viewBox: "0 0 14 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 14.4995H14V15.4995H0V14.4995Z",
                fill: "#757575"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 14.4995H14V15.4995H0V14.4995Z",
                fill: "#212121"
            })
        ]
    });
const LoadingIcon = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "spinner-border loadingIcon"
    });
};
const WarnIcon = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "B4-Cart",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "D_Kohler_UI_Batch-4,-Cart-Landing-Out-of-Stock-Promo-Error-ZipCode-1.2",
                transform: "translate(-806.000000, -1190.000000)",
                fill: "#D10000",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "Cart-Products",
                    transform: "translate(70.000000, 395.000000)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        id: "Product-Robern",
                        transform: "translate(0.000000, 644.000000)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            id: "03-Buttons/AlertMsg",
                            transform: "translate(731.000000, 146.000000)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M15.8865,19.128 L15.8865,21 L14.3565,21 L14.3565,19.128 L15.8865,19.128 Z M15.8865,8.148 L15.8865,17.454 L14.3565,17.454 L14.3565,8.148 L15.8865,8.148 Z",
                                    id: "Tool-Tip-Icon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M15,5 C20.5228475,5 25,9.4771525 25,15 C25,20.5228475 20.5228475,25 15,25 C9.4771525,25 5,20.5228475 5,15 C5,9.4771525 9.4771525,5 15,5 Z M15,5.66666667 C9.84534234,5.66666667 5.66666667,9.84534234 5.66666667,15 C5.66666667,20.1546577 9.84534234,24.3333333 15,24.3333333 C20.1546577,24.3333333 24.3333333,20.1546577 24.3333333,15 C24.3333333,9.84534234 20.1546577,5.66666667 15,5.66666667 Z",
                                    id: "Oval",
                                    "fill-rule": "nonzero"
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
const BackToTop = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "10",
        height: "30",
        viewBox: "0 0 10 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.95028 9.99955L5.00053 5.0498L0.0507812 9.99955L0.757888 10.7067L4.50053 6.96402V23.9996H5.50053V6.96402L9.24317 10.7067L9.95028 9.99955Z",
            fill: "#212121"
        })
    });
const LoaderSpinner = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "spinner-img d-flex justify-content-center align-items-center h-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: spinner.src,
            alt: "loading"
        })
    });
};
const ListViewSelected = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 10L-1.74846e-07 10L0 6L17 6L17 10Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 23L-7.43094e-07 23L-5.68248e-07 19L17 19L17 23Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M-4.5897e-07 16.5L17 16.5L17 12.5L-2.84124e-07 12.5L-4.5897e-07 16.5Z",
                fill: "#212121"
            })
        ]
    });
const GridViewUnSelected = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M7 6V13H0V6H7ZM6 7H1V12H6V7Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M17 6V13H10V6H17ZM16 7H11V12H16V7Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M7 23V16H0V23H7ZM1 17H6V22H1V17Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M17 16V23H10V16H17ZM16 17H11V22H16V17Z",
                fill: "#212121"
            })
        ]
    });
const CartCloseIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.7609 15.4989L7 22.9235L7.73913 23.6306L15.5 16.206L23.2609 23.6306L24 22.9235L16.2391 15.4989L24 8.07429L23.2609 7.36719L15.5 14.7918L7.73913 7.36719L7 8.07429L14.7609 15.4989Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.7609 15.4989L7 22.9235L7.73913 23.6306L15.5 16.206L23.2609 23.6306L24 22.9235L16.2391 15.4989L24 8.07429L23.2609 7.36719L15.5 14.7918L7.73913 7.36719L7 8.07429L14.7609 15.4989Z",
                fill: "white"
            })
        ]
    });

;// CONCATENATED MODULE: ./components/core/Conditional/Conditional.js
const Conditional = (props)=>{
    const { show , children  } = props;
    return show ? children : null;
};
/* harmony default export */ var Conditional_Conditional = (Conditional);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartsDiagramViewer/PopModal/index.js




const PopModal = (props)=>{
    var ref, ref1;
    const { position , setMessage , scale  } = props;
    const { isMobile  } = hooks_useViewport();
    const { left , top , textWidth , textBounds , textHeight  } = position;
    const normalizeDynamic = isMobile ? 3 : 6;
    const normalizeStatic = isMobile ? 4 : 7;
    const normalizedfactor = normalizeStatic + normalizeDynamic / scale;
    const popUpHeight = 114;
    const popUpWidth = 237;
    const wrapperTop = ((ref1 = (ref = document === null || document === void 0 ? void 0 : document.querySelector(".react-transform-wrapper")) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) === null || ref1 === void 0 ? void 0 : ref1.top) || 0;
    const textTop = textBounds === null || textBounds === void 0 ? void 0 : textBounds.top;
    const gap = textTop - wrapperTop;
    const leftStyle = left - popUpWidth / 2 + textWidth / 2;
    const nTop = top - textHeight / 2 + normalizeStatic / 2;
    const topStyle = gap > popUpHeight ? "".concat(nTop - (popUpHeight + normalizedfactor), "px") : "".concat(nTop + normalizedfactor, "px");
    const scaleTransform = "scale(".concat(1 / scale, ")");
    const scaleOrigin = gap > popUpHeight ? "bottom" : "top";
    const stylePosition = {
        left: "".concat(leftStyle, "px"),
        height: "".concat(popUpHeight, "px"),
        top: topStyle,
        transform: scaleTransform,
        transformOrigin: scaleOrigin
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "popup-window",
            style: stylePosition,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-popups",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title-notfound",
                            children: "PART NOT FOUND"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "button-close",
                            "data-testid": "part-not-found-close",
                            onClick: ()=>setMessage(false),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "content-popups",
                    children: "Please contact our customer service team"
                })
            ]
        })
    });
};
/* harmony default export */ var PartsDiagramViewer_PopModal = (PopModal);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/OverlayTrigger.js + 16 modules
var OverlayTrigger = __webpack_require__(84811);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tooltip.js
var Tooltip = __webpack_require__(43489);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/ToolTip/index.js



const ToolTip = (props)=>{
    const { children , text ="No text" , placement ="left" , show =true  } = props;
    return show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayTrigger/* default */.Z, {
        placement: placement,
        overlay: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
            className: "bg-color",
            children: text
        }),
        delay: {
            show: 0,
            hide: 0
        },
        children: children
    }, placement) : children;
};
/* harmony default export */ var v2_ToolTip = (ToolTip);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartsDiagramViewer/PartsControls/index.js






const PartsControls = (props)=>{
    const { zoomIn , zoomOut , expandHandler , fullscreen , scale , initScale , centerView , setMessage  } = props;
    const device = hooks_useViewport();
    const isDesktop = device.isLargeScreen || device.isExtraLargeScreen || device.isMediumScreen;
    const inMargin = (value, expected, margin)=>expected - margin < value && value < expected + margin;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "viewer-controls ".concat(isDesktop ? "position-absolute" : "position-fixed mobile-controls"),
        children: [
            fullscreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Coach_Coach, {
                text: "Exit Full Screen",
                displayKey: "bottom",
                hide: false
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: ()=>{
                    expandHandler();
                    setMessage(false);
                },
                className: "btn-expand",
                "data-testid": "parts-fullscreen",
                children: [
                    fullscreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCollapse, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconExpand, {}),
                    isDesktop && !fullscreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tool-tip-custom",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                !fullscreen ? "Full screen" : ""
                            ]
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ToolTip, {
                text: "Reset",
                show: isDesktop ? true : false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "".concat(inMargin(scale, initScale, 0.05) ? "" : "acitve"),
                    onClick: ()=>{
                        centerView(initScale);
                    },
                    "data-testid": "parts-center",
                    children: inMargin(scale, initScale, 0.05) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconReset, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetActive, {})
                })
            }),
            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ToolTip, {
                text: "Zoom",
                show: isDesktop ? true : false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "groups-buttons",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>{
                                zoomIn();
                            },
                            "data-testid": "parts-zoomin",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconZoomIn, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>{
                                zoomOut();
                            },
                            "data-testid": "parts-zoomout",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconZoomOut, {})
                        })
                    ]
                })
            }) : ""
        ]
    });
};
/* harmony default export */ var PartsDiagramViewer_PartsControls = (PartsControls);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/utils.js
const sortOptions = [
    {
        label: "A-Z",
        key: "asc"
    },
    {
        label: "Z-A",
        key: "desc"
    }
];
const LOCAL_PREFIX = "";

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartsDiagramViewer/interactiveSvg.js
const createInteractiveSVGElement = (svgText, actions)=>{
    var ref, ref1, ref2;
    const wrapper = document.createElement("div");
    wrapper.innerHTML = svgText;
    const svg = (ref = wrapper.getElementsByTagName("svg")) === null || ref === void 0 ? void 0 : ref[0];
    const groupNodeList = svg.querySelectorAll("g");
    const groupList = (ref1 = [
        ...groupNodeList
    ]) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>item.getAttribute("itedo:apstype") == "Part");
    groupList.forEach((item)=>{
        mutateGroupText(item);
    });
    const textNodeList = svg.querySelectorAll("text");
    const itemList = (ref2 = [
        ...textNodeList
    ]) === null || ref2 === void 0 ? void 0 : ref2.filter((item)=>item.getAttribute("itedo:apstype") == "Part");
    itemList.forEach((item)=>bindEvents(item, actions, svg));
    return svg;
};
/* harmony default export */ var interactiveSvg = (createInteractiveSVGElement);
const bindEvents = function(item, actions) {
    let context = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
    item.addEventListener("mouseover", (e)=>{
        const list = getObjectRelations(e.currentTarget);
        const relations = getNodes(list, context);
        addActionMultiple(relations, mouseOver);
    }, false);
    item.addEventListener("mouseout", (e)=>{
        const list = getObjectRelations(e.currentTarget);
        const relations = getNodes(list, context);
        addActionMultiple(relations, mouseOut);
    }, false);
    item.addEventListener("click", (e)=>{
        const list = getObjectRelations(e.currentTarget);
        const relations = getNodes(list, context);
        actions.click(e, relations);
    }, false);
};
const mutateGroupText = (groupNode)=>{
    var ref;
    const textList = groupNode.querySelectorAll("text");
    const hotspotList = groupNode.getAttribute("kohler_illustration:hotspot_list");
    (ref = [
        ...textList
    ]) === null || ref === void 0 ? void 0 : ref.forEach((item)=>{
        item.classList.add(groupNode.classList);
        item.setAttribute("kohler_illustration:hotspot_list", hotspotList);
        item.setAttribute("itedo:apstype", "Part");
    });
};
const addActionMultiple = (list, action)=>list.forEach((node)=>action(node));
const getNodes = (list, context)=>list.map((id)=>context.getElementById(id));
const getObjectRelations = (node)=>{
    const listString = node.getAttribute("kohler_illustration:hotspot_list");
    let list = [];
    if (typeof listString == "string") list = listString.split(",");
    return list;
};
const mouseOver = (node)=>node.classList.add("active");
const mouseOut = (node)=>node.classList.remove("active");

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartsDiagramViewer/index.js









const PartsDiagramViewer = (props)=>{
    const { selectedFile , fullscreen , expandHandler , showPopup , title , sku  } = props;
    const transformComponentRef = (0,react.useRef)(null);
    const wrapper = (0,react.useRef)(null);
    const container = (0,react.useRef)(null);
    const [svgData, setSvgData] = (0,react.useState)();
    const [status, setStatus] = (0,react.useState)("loading");
    const [scale, setScale] = (0,react.useState)(1);
    const [initScale, setInitScale] = (0,react.useState)(1);
    const [message, setMessage] = (0,react.useState)(false);
    const [position, setPosition] = (0,react.useState)({
        left: 0,
        top: 0,
        textWidth: 0,
        textHeight: 0,
        showTop: 0,
        textBounds: {}
    });
    (0,react.useEffect)(()=>{
        const aspect = container.current.offsetHeight / container.current.offsetWidth * 0.85;
        setInitScale(aspect > 0.9 ? aspect : 0.9);
        return ()=>{
            container.current = false;
        };
    }, []);
    (0,react.useEffect)(()=>{
        setMessage(false);
        setStatus("loading");
        const abortController = new AbortController();
        getSelectedFile(abortController);
        return ()=>{
            abortController.abort();
            setMessage(false);
            setStatus("loading");
            setSvgData("");
        };
    }, [
        selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.URL
    ]);
    (0,react.useEffect)(()=>{
        if (wrapper === null || wrapper === void 0 ? void 0 : wrapper.current) wrapper.current.appendChild(svgData);
    }, [
        svgData,
        position
    ]);
    const getSelectedFile = async (abortController)=>{
        try {
            const response = await fetch(LOCAL_PREFIX + (selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.URL), {
                signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal
            });
            const svgText = await response.text();
            const svgElement = interactiveSvg(svgText, {
                click: clickAction
            });
            setStatus("loaded");
            setSvgData(svgElement);
        } catch (error) {
            setStatus("error");
        }
    };
    const clickAction = async (e, relations)=>{
        setMessage(false);
        let text = e.currentTarget.getAttribute("class");
        text = text.replaceAll("active", "").replaceAll(" ", "");
        if (selectedFile.Parts.filter((item)=>item.Cod == text).length == 0) {
            partNotFoundMessage(e.currentTarget);
            setMessage(true);
            showPopup(text);
        } else {
            showPopup(text);
        }
    };
    const partNotFoundMessage = (textNode)=>{
        const svgElement = wrapper.current.children[0];
        const viewBox = svgElement.getAttribute("viewBox").split(" ");
        const boxWidth = viewBox === null || viewBox === void 0 ? void 0 : viewBox[2];
        const boxHeight = viewBox === null || viewBox === void 0 ? void 0 : viewBox[3];
        const boxAspect = boxWidth / boxHeight;
        const { top  } = textNode.getBoundingClientRect();
        const svgWidth = svgElement.width.baseVal.value;
        const svgHeight = svgElement.height.baseVal.value;
        const wrapperWidth = wrapper.current.offsetWidth;
        const wrapperHeight = wrapper.current.offsetHeight;
        const wrapperAspect = wrapperWidth / wrapperHeight;
        let leftOffset = 0;
        let topOffset = 0;
        let leftValue = 0;
        let topValue = 0;
        let actualSVGWidth = 0;
        let actualSVGHeight = 0;
        let svgScaleVertical = 1;
        let svgScaleHorizontal = 1;
        if (wrapperAspect > boxAspect) {
            actualSVGWidth = svgHeight * boxAspect;
            actualSVGHeight = svgHeight;
            leftOffset = (svgWidth - actualSVGWidth) / 2;
            topOffset = 0;
        } else {
            actualSVGWidth = svgWidth;
            actualSVGHeight = svgWidth / boxAspect;
            leftOffset = 0;
            topOffset = (svgHeight - actualSVGHeight) / 2;
        }
        svgScaleHorizontal = actualSVGWidth / boxWidth;
        svgScaleVertical = actualSVGHeight / boxHeight;
        leftValue = textNode.getAttribute("x") / boxWidth * actualSVGWidth;
        topValue = textNode.getAttribute("y") / boxHeight * actualSVGHeight;
        setPosition({
            left: leftValue + leftOffset,
            top: topValue + topOffset,
            textWidth: textNode.getComputedTextLength() * svgScaleHorizontal,
            textHeight: textNode.getBBox().height * svgScaleVertical / scale,
            showTop: top,
            textBounds: textNode.getBoundingClientRect()
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Conditional_Conditional, {
                show: status == "loading",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "d-flex w-100 h-100 justify-content-center align-items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderSpinner, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-wrapper",
                        ref: container
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditional_Conditional, {
                show: status == "loaded",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TransformWrapper */.d$, {
                    initialScale: initScale,
                    velocityAnimation: {
                        disabled: true
                    },
                    ref: transformComponentRef,
                    zoomAnimation: {
                        disabled: true
                    },
                    centerOnInit: true,
                    minScale: 0.5,
                    onTransformed: (e)=>{
                        var ref;
                        return setScale(e === null || e === void 0 ? void 0 : (ref = e.state) === null || ref === void 0 ? void 0 : ref.scale);
                    },
                    onInit: ()=>{},
                    pinch: {
                        step: 2
                    },
                    wheel: {
                        step: 0.1
                    },
                    children: (utils)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* TransformComponent */.Uv, {
                                    children: [
                                        message ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsDiagramViewer_PopModal, {
                                            position: position,
                                            setMessage: setMessage,
                                            scale: scale
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image-wrapper",
                                            ref: wrapper
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsDiagramViewer_PartsControls, {
                                    ...utils,
                                    expandHandler: expandHandler,
                                    fullscreen: fullscreen,
                                    scale: scale,
                                    initScale: initScale,
                                    setMessage: setMessage,
                                    title: title,
                                    sku: sku
                                })
                            ]
                        })
                })
            })
        ]
    });
};
/* harmony default export */ var v2_PartsDiagramViewer = (PartsDiagramViewer);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./constants/regex.js
var regex = __webpack_require__(49139);
;// CONCATENATED MODULE: ./components/core/Heading/Heading.jsx



const Heading = (props)=>{
    const { level =6 , fontSize , fontWeight , className ="" , children  } = props;
    const Tag = regex/* NUMBER_HEADING_REGEX.test */.uZ.test("".concat(level)) ? "h" + level : "h6";
    let classes = "";
    classes = (fontSize ? "fs-".concat(fontSize) : "") + " ";
    classes += fontWeight ? "fw-".concat(fontWeight) : "";
    if (!classes) classes = "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        className: "".concat(classes, " ").concat(className),
        children: children
    });
};
/* harmony default export */ var Heading_Heading = (Heading);

// EXTERNAL MODULE: ./components/core/ColorSwatch/ColorSwatch.jsx
var ColorSwatch = __webpack_require__(32982);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/SwatchItems/index.js



const SwatchItems = (props)=>{
    const { varentList , setVarent , varent  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "swatch-list d-flex",
            children: varentList === null || varentList === void 0 ? void 0 : varentList.map((val, i)=>{
                var ref;
                const validSwatch = val === null || val === void 0 ? void 0 : (ref = val.colorUrl) === null || ref === void 0 ? void 0 : ref.split("/");
                if (validSwatch[validSwatch.length - 1] === "swatch_NA") {
                    return null;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    role: "radio",
                    tabIndex: 0,
                    "aria-label": val.label,
                    "aria-checked": val.id == varent ? true : false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSwatch["default"], {
                        type: "selector",
                        id: val.id,
                        name: val.name,
                        value: val.value,
                        label: val.label,
                        colorUrl: val.colorUrl,
                        checked: (val === null || val === void 0 ? void 0 : val.id) == varent,
                        onClick: ()=>{
                            return setVarent(val === null || val === void 0 ? void 0 : val.id);
                        }
                    }, i)
                }, "".concat(val === null || val === void 0 ? void 0 : val.id, "-").concat(i));
            })
        })
    });
};
/* harmony default export */ var v2_SwatchItems = (SwatchItems);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./components/ProductDetail/v3/AddToCart/utils.js
var utils = __webpack_require__(29885);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/DetailPopUp/NotifyMe/index.js






const NotifyItems = (param)=>{
    let { item  } = param;
    const [email, setEmail] = (0,react.useState)("");
    const [emailError, setEmailError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [showWelcome, setShowWelcome] = (0,react.useState)(false);
    const [enableNotify, setEnableNotify] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setShowWelcome(false);
        setEmailError({
            show: false,
            message: ""
        });
        setEmail("");
    }, [
        item
    ]);
    const handleEmailChange = async (val)=>{
        const inputValue = val.trim();
        setEmailError({
            show: false,
            message: ""
        });
        setEmail(inputValue);
        if (!await (0,helper.validateField)("email", inputValue)) {
            setEnableNotify(false);
        } else {
            setEnableNotify(true);
        }
    };
    const callBackNotify = (isSuccess)=>{
        if (isSuccess) {
            setShowWelcome(true);
            setEmail("");
            setEnableNotify(false);
        } else {
            setEmailError({
                show: true,
                message: "Notification has been sent already for this email address"
            });
        }
    };
    const handleNotification = ()=>{
        var ref;
        const sku = item === null || item === void 0 ? void 0 : (ref = item.currentVarent) === null || ref === void 0 ? void 0 : ref.id;
        if (sku) (0,utils.callNotification)({
            email,
            sku,
            callBackNotify
        });
    };
    const handlerSubmit = (event)=>{
        if (event.key === "Enter" && enableNotify) {
            handleNotification();
        }
    };
    const handlerNotify = ()=>{
        if (enableNotify) {
            handleNotification();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                className: "notify-contianer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "fs-16 fw-500 notify-heading ",
                        children: showWelcome ? "Success!" : "This Item is currently Out of Stock on Kohler.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "fs-14 fw-400 notify-details ",
                        children: showWelcome ? "Thank you! We will notify you as soon as the item requested is back in stock." : "Enter your email to be notified when this item is back in stock online or check availability at a local store or showroom."
                    }),
                    !showWelcome ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "email-inputbox",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input["default"], {
                                    id: "email-notify",
                                    onChange: (e)=>handleEmailChange(e.target.value),
                                    onKeyDown: handlerSubmit,
                                    type: "email",
                                    label: "Email Address",
                                    ariaRequried: true,
                                    maxLength: 60,
                                    value: email,
                                    showError: emailError.show,
                                    errorMessage: emailError.message
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "notify-button ".concat(enableNotify ? "" : "disabled-btn"),
                                onClick: handlerNotify,
                                disabled: !enableNotify,
                                children: "Notify me"
                            })
                        ]
                    }) : ""
                ]
            })
        })
    });
};
/* harmony default export */ var NotifyMe = (NotifyItems);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/DetailPopUp/Loading/index.js





const LoadingPopupection = (props)=>{
    const { setModal , device , popupWidth , fullscreen  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "popup-default loading-popup",
        style: popupWidth && !device.isSmallScreen ? {
            width: (popupWidth === null || popupWidth === void 0 ? void 0 : popupWidth.sidebarWidth) + "px",
            top: !fullscreen ? popupWidth === null || popupWidth === void 0 ? void 0 : popupWidth.headHeight : 0 + "px"
        } : {},
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            fluid: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "d-flex justify-content-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn closebtns",
                            onClick: ()=>setModal(false),
                            children: (device === null || device === void 0 ? void 0 : device.isLargeScreen) || device.isExtraLargeScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DownIcon, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex  flex-column align-items-center mt-4 mb-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "loading-thumb mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderSpinner, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex  flex-column justify-content-start mb-30",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation loading-heading mb-4",
                                    children: "new"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation mt-4 mb-4 h-16",
                                    children: "Widespread bathroom sink faucet"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation loading-heading",
                                    children: "K-5709-7"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex  flex-column justify-content-start mb-30",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation loading-heading",
                                    children: "$800.44"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation mt-3 mb-2 h-16 loading-heading",
                                    children: "$1000.44 List Price"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex  flex-column justify-content-start mb-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "loading-animation loading-heading h-16",
                                children: "color/Finish white"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-30 w-100",
                            children: Array.from({
                                length: 9
                            }, (v, index)=>index + 1).map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation loading-buttons mb-2",
                                    children: "color Finish"
                                }, val))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-100 d-flex flex-rows justify-content-between align-content-center mb-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation counter-details",
                                    children: "counter"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation addtocart-details",
                                    children: "Add to cart"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
LoadingPopupection.propTypes = {
    fullscreen: (prop_types_default()).bool.isRequired,
    setModal: (prop_types_default()).func.isRequired,
    popupWidth: prop_types_default().shape({
        headHeight: (prop_types_default()).number
    }),
    device: (prop_types_default()).object.isRequired
};
/* harmony default export */ var Loading = (LoadingPopupection);

// EXTERNAL MODULE: ./components/sharedCart/shareCartHelper.js
var shareCartHelper = __webpack_require__(4364);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/api.js
var api = __webpack_require__(9670);
;// CONCATENATED MODULE: ./services/ImageUrlValid.js
const isImgUrlValid = (url)=>{
    try {
        const img = new Image();
        img.src = url;
        return new Promise((resolve)=>{
            img.onerror = ()=>resolve(false);
            img.onload = ()=>resolve(true);
        });
    } catch (err) {
        throw new Error("Invalid Image");
    }
};

;// CONCATENATED MODULE: ./public/scout_icon/coming-soon.jpg
/* harmony default export */ var coming_soon = ({"src":"/_next/static/media/coming-soon.c51c0af8.jpg","height":375,"width":337,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAgABwMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAAsYP/xAAbEAABBAMAAAAAAAAAAAAAAAACAAEDESFBgf/aAAgBAQABPwAaaYsa4v/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQIBAT8Af//EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQMBAT8Af//Z","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./components/PartsViewer/v2/analytics.js

const partsAddToCartEvent = (analytics, productInfo)=>{
    const { page ="n/a"  } = analytics;
    const linkUrl = "n/a";
    const event = "cmp:click";
    const eventInfo = {
        eventAction: page + ":interactive parts diagram:add to cart",
        eventName: page + ":interactive parts diagram:add to cart",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "add to cart",
        internalLinkPosition: page,
        internalLinkType: page + ":add to cart",
        internalLinkZoneName: page + ":modal:interactive parts diagram",
        internalLinkURL: linkUrl,
        clickInternalLinks: "true"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo, event, getAnalyticProductInfo(productInfo));
};
const getAnalyticProductInfo = (pdpInfo)=>{
    var ref, ref1;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page");
    const { Name ="" , quantity =0 , fileTitle ="" , currentVarent: { imgUrl , label , centPrice , value  } , data: { ProductDescriptionProduct_s: productDescription , ProductCategory_s: productCategory  } , pdpDetails: { pdp  }  } = pdpInfo;
    const productInfo = {
        category: pdp === null || pdp === void 0 ? void 0 : (ref = pdp.data) === null || ref === void 0 ? void 0 : ref.category1_s,
        defaultImageName: imgUrl,
        description: (0,helper.sanitizeTextForAnalytics)(productDescription || Name),
        frequency: "n/a",
        globalDiscount: 0,
        globalOffer: "n/a",
        globalPromotionPrice: centPrice,
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        itemType: (0,helper.sanitizeTextForAnalytics)(productCategory),
        numberOfReviews: "n/a",
        pdpType: "regular finished goods & service parts",
        priceState: "regular price",
        productBasePrice: centPrice,
        productBrand: "kohler",
        productCategory: (0,helper.sanitizeTextForAnalytics)(productCategory),
        productCollectionsName: pdp === null || pdp === void 0 ? void 0 : pdp.productBrand,
        productColor: (0,helper.sanitizeTextForAnalytics)(label),
        productCouponCode: "n/a",
        productCoupondiscount: 0,
        productFindingMethod: "pdp:".concat(fileTitle),
        productID: value,
        productName: (0,helper.sanitizeTextForAnalytics)(Name),
        productPartnerBuyNow: false,
        productRoom: page === null || page === void 0 ? void 0 : (ref1 = page.category) === null || ref1 === void 0 ? void 0 : ref1.room,
        productSalePrice: centPrice,
        productSaleable: true,
        productStatus: "in stock",
        productSuperSku: true,
        productTileName: (0,helper.sanitizeTextForAnalytics)(Name),
        quantity,
        ratings: "n/a",
        waterSenseProduct: false
    };
    page.productInfo = productInfo;
    return page;
};

;// CONCATENATED MODULE: ./components/PartsViewer/v2/DetailPopUp/index.js
















const DetailPopUp = (props)=>{
    const { productId , setModal , partController , analytics , title , fullscreen , setWidthSize  } = props;
    const [loading, setLoading] = (0,react.useState)("loading");
    const [item, setItems] = (0,react.useState)({});
    const [varent, setVarent] = (0,react.useState)(null);
    const [varentList, setVarentList] = (0,react.useState)([]);
    const [counter, setCounter] = (0,react.useState)(1);
    const [isloading, setIsLoading] = (0,react.useState)(false);
    const [inventory, setInventory] = (0,react.useState)("");
    const [inventoryWarn, setInventoryWarn] = (0,react.useState)(false);
    const [cartToast, setCartToast] = (0,react.useState)(false);
    const [popupWidth, setPopupWidth] = (0,react.useState)(null);
    const [isValidImg, setIsValidImg] = (0,react.useState)(false);
    const showStockDiscontinue = null;
    const device = hooks_useViewport();
    const resizeWidth = useViewportWidth();
    const pdpDetails = (0,es/* useSelector */.v9)((state)=>state.pdp);
    (0,react.useEffect)(()=>{
        const element = document.getElementsByClassName("product-list-viewer")[0];
        const headElement = document.querySelectorAll(".modal-fullscreen.modal-container")[0];
        if (element) {
            const { width  } = element.getBoundingClientRect();
            const { height  } = headElement.getBoundingClientRect();
            setWidthSize(width);
            setPopupWidth({
                sidebarWidth: width,
                headHeight: height
            });
        }
    }, [
        resizeWidth
    ]);
    (0,react.useEffect)(()=>{
        getItemDetails(productId);
    }, [
        productId
    ]);
    (0,react.useEffect)(()=>{
        let timeId;
        if (inventory && counter > inventory) {
            timeId = setTimeout(()=>{
                setCounter(inventory);
            }, 1000);
            setInventoryWarn(true);
        }
        return ()=>clearTimeout(timeId);
    }, [
        counter
    ]);
    (0,react.useEffect)(()=>{
        getVarientInfo();
    }, [
        varent
    ]);
    const getVarientInfo = async ()=>{
        const currentVarent = varentList === null || varentList === void 0 ? void 0 : varentList.filter((val)=>val.id === varent)[0];
        if (currentVarent) {
            var ref;
            const isImgValid = await isImgUrlValid(item === null || item === void 0 ? void 0 : (ref = item.currentVarent) === null || ref === void 0 ? void 0 : ref.imgUrl);
            setIsValidImg(isImgValid);
            setIsLoading(true);
            const productQuantity = await getInventoryBySku(currentVarent === null || currentVarent === void 0 ? void 0 : currentVarent.id);
            setIsLoading(false);
            setItems((prevState)=>{
                var ref, ref1;
                const details = prevState === null || prevState === void 0 ? void 0 : (ref = prevState.data) === null || ref === void 0 ? void 0 : (ref1 = ref.varientDetails) === null || ref1 === void 0 ? void 0 : ref1.filter((val)=>{
                    return (val === null || val === void 0 ? void 0 : val.sku) === (currentVarent === null || currentVarent === void 0 ? void 0 : currentVarent.id);
                })[0];
                return {
                    ...prevState,
                    currentVarent: {
                        ...currentVarent,
                        details
                    }
                };
            });
            setInventory(productQuantity);
            setInventoryWarn(false);
            if (productQuantity && counter > productQuantity) {
                setCounter(productQuantity);
                setInventoryWarn(true);
            }
        }
    };
    const getItemDetails = async (id)=>{
        const entry = partController.actions.get.entryByKey(id);
        setLoading("loading");
        if (entry === null || entry === void 0 ? void 0 : entry.ctApiPromise) {
            const ctResponse = await entry.ctApiPromise;
            if (ctResponse) {
                var ref, ref1, ref2, ref3, ref4;
                setIsLoading(true);
                const allSwatch = ctResponse === null || ctResponse === void 0 ? void 0 : (ref = ctResponse.data) === null || ref === void 0 ? void 0 : ref.colorData;
                const isImgValid = await isImgUrlValid(allSwatch === null || allSwatch === void 0 ? void 0 : (ref1 = allSwatch[0]) === null || ref1 === void 0 ? void 0 : ref1.imgUrl);
                setIsValidImg(isImgValid);
                const currentSwatch = allSwatch === null || allSwatch === void 0 ? void 0 : (ref2 = allSwatch[0]) === null || ref2 === void 0 ? void 0 : ref2.id;
                const productQuantity = await getInventoryBySku(currentSwatch);
                const details = ctResponse === null || ctResponse === void 0 ? void 0 : (ref3 = ctResponse.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.varientDetails) === null || ref4 === void 0 ? void 0 : ref4.filter((val)=>{
                    return (val === null || val === void 0 ? void 0 : val.sku) === currentSwatch;
                })[0];
                setIsLoading(false);
                setInventory(productQuantity);
                setVarentList(allSwatch);
                setVarent(currentSwatch);
                setItems({
                    ...ctResponse,
                    currentVarent: {
                        ...allSwatch[0],
                        details
                    }
                });
                setLoading("success");
            }
        }
    };
    const incrementCounter = ()=>{
        setCounter(counter + 1);
    };
    const decrementCounter = ()=>{
        if (counter > 1) setCounter(counter - 1);
    };
    const handlerCounter = (val)=>{
        const count = Number(val);
        if (count && count >= 1) {
            setCounter(count);
        }
    };
    const handlerCart = (productInfo)=>{
        var ref;
        setIsLoading(true);
        const data = [
            {
                sku: productInfo === null || productInfo === void 0 ? void 0 : (ref = productInfo.currentVarent) === null || ref === void 0 ? void 0 : ref.id,
                quantity: counter,
                isBundleProduct: false,
                isBundle: false,
                brand: "kohler"
            }
        ];
        (0,shareCartHelper.shareaddToCart)(data, "", (res)=>{
            if (res) {
                setCartToast(true);
                setIsLoading(false);
                partsAddToCartEvent(analytics, productInfo);
                setTimeout(()=>{
                    setCartToast(false);
                }, 3000);
            }
        });
    };
    const getInventoryBySku = async (sku)=>{
        var ref;
        var ref1;
        const { data: { results: parentProductInventory = []  } = {}  } = (ref1 = await (0,api/* getProductInventory */.o)(sku)) !== null && ref1 !== void 0 ? ref1 : {};
        return parentProductInventory.length ? (ref = parentProductInventory[0]) === null || ref === void 0 ? void 0 : ref.availableQuantity : 0;
    };
    if (popupWidth) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
        if (loading === "loading") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {
                setModal: setModal,
                device: device,
                popupWidth: popupWidth,
                fullscreen: fullscreen
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "popup-default",
            style: popupWidth && !device.isSmallScreen ? {
                width: (popupWidth === null || popupWidth === void 0 ? void 0 : popupWidth.sidebarWidth) + "px",
                top: !fullscreen ? popupWidth.headHeight : 0 + "px"
            } : {},
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "popup-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        fluid: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-column content-dialogs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "header-fixed",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex justify-content-start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn closebtns",
                                            onClick: ()=>{
                                                setModal(false);
                                            },
                                            "data-testid": "parts-modal-close",
                                            children: (device === null || device === void 0 ? void 0 : device.isLargeScreen) || device.isExtraLargeScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DownIcon, {})
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "main-image mt-0",
                                    children: loading === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderSpinner, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: isValidImg ? item === null || item === void 0 ? void 0 : (ref = item.currentVarent) === null || ref === void 0 ? void 0 : ref.imgUrl : coming_soon === null || coming_soon === void 0 ? void 0 : coming_soon.src,
                                        alt: "comming soon"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flag-container",
                                            children: [
                                                (item === null || item === void 0 ? void 0 : (ref1 = item.currentVarent) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.details) === null || ref2 === void 0 ? void 0 : ref2.discontinued) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fs-13 fw-600 tag-discontinue discontinued",
                                                    children: "Discontinued"
                                                }) : null,
                                                ((item === null || item === void 0 ? void 0 : (ref3 = item.currentVarent) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.details) === null || ref4 === void 0 ? void 0 : ref4.isStock) === "false" || inventory === 0) && (item === null || item === void 0 ? void 0 : (ref5 = item.currentVarent) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.details) === null || ref6 === void 0 ? void 0 : ref6.discontinued) === false ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fs-13 fw-600 tag-discontinue outof-stoke",
                                                    children: "out of stock"
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading_Heading, {
                                            level: 2,
                                            className: "label-name fs-28 fw-325 text-capitalize",
                                            children: (item === null || item === void 0 ? void 0 : (ref7 = item.Name) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase()) || "N/A"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "varient-text fs-14 fw-500",
                                            children: (item === null || item === void 0 ? void 0 : (ref8 = item.currentVarent) === null || ref8 === void 0 ? void 0 : ref8.value) || "N/A"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading_Heading, {
                                            level: 2,
                                            className: "price-text fs-28 fw-325 text-capitalize",
                                            children: [
                                                item === null || item === void 0 ? void 0 : (ref9 = item.currentVarent) === null || ref9 === void 0 ? void 0 : ref9.currencySign,
                                                item === null || item === void 0 ? void 0 : (ref10 = item.currentVarent) === null || ref10 === void 0 ? void 0 : ref10.price
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "pricelist-text fs-16 fw-400 product-description mb-2",
                                            children: [
                                                item === null || item === void 0 ? void 0 : (ref11 = item.currentVarent) === null || ref11 === void 0 ? void 0 : ref11.currencySign,
                                                item === null || item === void 0 ? void 0 : (ref12 = item.currentVarent) === null || ref12 === void 0 ? void 0 : ref12.pricelist,
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "list-text",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: " List Price"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "list-description",
                                                            children: [
                                                                "Selling price is valid for ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                    children: "Kohler.com"
                                                                }),
                                                                " and United States only. Store and distribution pricing may differ. These prices do not include potential shipping costs. Any sales tax applicable will be added to the price."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "fs-16 fw-300 text-color",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "fw-400",
                                                    children: "Color/Finish "
                                                }),
                                                (item === null || item === void 0 ? void 0 : (ref13 = item.currentVarent) === null || ref13 === void 0 ? void 0 : ref13.label) || "N/A"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_SwatchItems, {
                                            varentList: varentList,
                                            setVarent: setVarent,
                                            varent: varent
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "d-flex align-items-center justify-content-center detailpop-up",
                                            children: showStockDiscontinue != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "fw-400 stock-button mt-5",
                                                disabled: true,
                                                children: showStockDiscontinue
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "button-carts d-flex flex-row justify-content-center align-items-end mt-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-flex flex-column processing-div ".concat(isloading ? "processing" : ""),
                                                    children: [
                                                        inventoryWarn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "inventory-warning",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WarnIcon, {}),
                                                                " ",
                                                                inventory,
                                                                " item(s) available to ship."
                                                            ]
                                                        }) : "",
                                                        !(item === null || item === void 0 ? void 0 : (ref14 = item.currentVarent) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.details) === null || ref15 === void 0 ? void 0 : ref15.discontinued) && loading === "success" && inventory ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "addtocart-widgets d-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "counter-widgets d-flex",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                            className: "decrement-widgets",
                                                                            onClick: decrementCounter,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DecIcon, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            type: "number",
                                                                            onChange: (e)=>{
                                                                                var ref;
                                                                                return handlerCounter(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                                            },
                                                                            value: counter
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                            className: "increment-widgets",
                                                                            onClick: incrementCounter,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IncIcon, {})
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "button-carts",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        onClick: ()=>!isloading ? handlerCart({
                                                                                ...item,
                                                                                fileTitle: title,
                                                                                quantity: counter,
                                                                                pdpDetails
                                                                            }) : null,
                                                                        disabled: isloading,
                                                                        type: "button",
                                                                        className: "fs-18 fw-500 add-to-cart d-flex align-items-center justify-content-center ".concat(isloading ? "disabled" : "", "\n                        "),
                                                                        children: isloading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingIcon, {}) : "Add to Cart"
                                                                    })
                                                                })
                                                            ]
                                                        }) : "",
                                                        ((item === null || item === void 0 ? void 0 : (ref16 = item.currentVarent) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.details) === null || ref17 === void 0 ? void 0 : ref17.isStock) === "false" || inventory === 0) && !(item === null || item === void 0 ? void 0 : (ref18 = item.currentVarent) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.details) === null || ref19 === void 0 ? void 0 : ref19.discontinued) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NotifyMe, {
                                                            item: item
                                                        }) : ""
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                cartToast ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cart-toast-text",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "( ",
                                counter,
                                " ) ",
                                counter > 1 ? "Items" : "Item",
                                " has been added to your cart."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>setCartToast(false),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartCloseIcon, {})
                        })
                    ]
                }) : ""
            ]
        });
    }
};
DetailPopUp.propTypes = {
    productId: (prop_types_default()).string.isRequired,
    setModal: (prop_types_default()).func.isRequired,
    analytics: (prop_types_default()).object.isRequired,
    title: (prop_types_default()).string.isRequired,
    fullscreen: (prop_types_default()).bool.isRequired,
    setWidthSize: (prop_types_default()).func.isRequired,
    partController: prop_types_default().shape({
        actions: prop_types_default().shape({
            get: prop_types_default().shape({
                entryByKey: (prop_types_default()).func.isRequired
            })
        })
    })
};
/* harmony default export */ var v2_DetailPopUp = (DetailPopUp);

// EXTERNAL MODULE: ./components/core/RadioButton/RadioButton.jsx
var RadioButton = __webpack_require__(65131);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/ToggleView/index.js



const ToggleView = (props)=>{
    const { listView , setlistView , device  } = props;
    const isDesktop = device.isExtraLargeScreen || device.isLargeScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "btn-group btn-group-toggle",
            "data-toggle": "buttons",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "btn-expand grid-btn border-0 ".concat(isDesktop || (device === null || device === void 0 ? void 0 : device.isMediumScreen) ? "pr-15" : "pr-15 pl-20", " ").concat(listView ? "" : "active"),
                    onClick: (event)=>{
                        event.preventDefault();
                        event.stopPropagation();
                        setlistView(false);
                    },
                    "data-testid": "select-grid-view",
                    children: [
                        !listView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGridViewMobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GridViewUnSelected, {}),
                        isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tool-tip-custom bottom grid-list-view",
                            children: "Grid View"
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "btn-expand list-btn border-0 ".concat(listView ? "active" : ""),
                    onClick: (event)=>{
                        event.preventDefault();
                        event.stopPropagation();
                        setlistView(true);
                    },
                    children: [
                        listView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListViewSelected, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageListViewMobile, {}),
                        isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tool-tip-custom bottom grid-list-view",
                            children: "List View"
                        }) : null
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var GridAndListPanel_ToggleView = (ToggleView);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/SortDropdown/index.js







const SortDropdown = (props)=>{
    const { partController , visibleData , title , sku , setlistView , listView , isListExtend  } = props;
    const [sort, setSort] = (0,react.useState)("asc");
    const [sortDesc, setSortDesc] = (0,react.useState)("A-Z");
    const device = hooks_useViewport();
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const isDesktop = device.isLargeScreen || device.isExtraLargeScreen;
    const toogleDropDown = ()=>{
        setIsOpen((prevOpen)=>!prevOpen);
    };
    const sortBy = (e, order)=>{
        setIsOpen(false);
        partController.actions.filterProduct(order.key);
        partController.actions.fetchForCpiPromise(visibleData);
        setSortDesc(order.label);
        setSort(order.key);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "drop-down",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    id: "dropdown-basic",
                    "aria-expanded": "false",
                    "data-testid": "sort-dropdown",
                    className: "sorting-btn btn btn-expand border-0 ".concat(isListExtend ? "full-screen-view" : "small-screen-view"),
                    onClick: toogleDropDown,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: isDesktop ? "Sort By: ".concat(sortDesc) : "Sort"
                        }),
                        isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByDropDownIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByIcon, {}),
                        device.isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_ToggleView, {
                            listView,
                            setlistView,
                            device,
                            title,
                            sku
                        }) : null
                    ]
                }),
                isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "drop-down-menu border-0 ".concat(device.isSmallScreen ? "mobile-dropdown" : ""),
                    children: [
                        device.isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sort-div d-flex justify-content-between align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "sort-by-title",
                                        children: "Sort "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "close-icon",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: toogleDropDown,
                                            className: "close-menu",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose, {})
                                        })
                                    })
                                ]
                            })
                        }) : null,
                        sortOptions.map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "data-testid": "sort-".concat(val.key),
                                className: "dropdown-item drop-link ".concat(sort === val.key ? "sort-by" : ""),
                                onClick: (event)=>sortBy(event, val),
                                children: device.isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "sort__radio-group",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                        id: val.key,
                                        name: val.key,
                                        value: val.label,
                                        checked: sort === val.key
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: val.label
                                })
                            }, val.key))
                    ]
                }) : null,
                device.isSmallScreen && isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mobile-overlay"
                }) : null
            ]
        })
    });
};
/* harmony default export */ var GridAndListPanel_SortDropdown = (SortDropdown);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/helper.js

const isObjectEmpty = (objectName)=>{
    return Object.keys(objectName).length === 0;
};
const getPersonaPriceDetails = (priceDtl)=>{
    var ref;
    const persona = (0,helper.getUserPersona)();
    const result = [];
    const filerPrice = priceDtl === null || priceDtl === void 0 ? void 0 : (ref = priceDtl.prices) === null || ref === void 0 ? void 0 : ref.filter((elemet)=>{
        return !isObjectEmpty(elemet === null || elemet === void 0 ? void 0 : elemet.prices);
    });
    filerPrice === null || filerPrice === void 0 ? void 0 : filerPrice.map((price)=>{
        if (Object.keys(price === null || price === void 0 ? void 0 : price.prices) != 0) {
            var ref, ref1;
            result.push({
                currencySign: (price === null || price === void 0 ? void 0 : price.currencySign) ? price === null || price === void 0 ? void 0 : price.currencySign : $,
                sku: price === null || price === void 0 ? void 0 : price.sku,
                price: (price === null || price === void 0 ? void 0 : price.prices[persona]) ? (((ref = price === null || price === void 0 ? void 0 : price.prices[persona]) === null || ref === void 0 ? void 0 : ref.centAmount) / 100).toFixed(2) : 0.0,
                pricelist: (price === null || price === void 0 ? void 0 : price.prices["ANY"]) ? (((ref1 = price === null || price === void 0 ? void 0 : price.prices["ANY"]) === null || ref1 === void 0 ? void 0 : ref1.centAmount) / 100).toFixed(2) : 0.0
            });
        }
    });
    return result;
};

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/GridView/LoadingGrid/index.js


const GridCardLoading = (param)=>{
    let { isListExtend  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card d-flex load-widgets flex-column justify-content-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                class: "shimmer-loading__image shimmer ".concat(isListExtend ? "grid-fullwidth" : "thumb-size", " ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-flex flex-column justify-content-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "width-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex",
                            children: [
                                Array.from({
                                    length: 5
                                }, (val, index)=>index + 1).map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        class: "shimmer-loading__para shimmer width-20"
                                    }, val)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: " width-16 loading-part mx-1 shimmer-loading__para shimmer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            class: "shimmer-loading__para shimmer width-191 loading-part"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            class: "shimmer-loading__para shimmer width-102 loading-part"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: "shimmer-loading__para shimmer width-15 loading-part"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: "shimmer-loading__para shimmer width-15 mx-3 loading-part"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var LoadingGrid = (GridCardLoading);

// EXTERNAL MODULE: ./public/images/swatch-missing.jpeg
var swatch_missing = __webpack_require__(36562);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/GridView/index.js









const GridView = (props)=>{
    var ref;
    const { dataPromise , showPopup , isListExtend , dataInput  } = props;
    const [validUrl, setValidUrl] = (0,react.useState)({
        status: "loading"
    });
    const [loading, setLoading] = (0,react.useState)("notStarted");
    const [productSwatche, setProductSwatche] = (0,react.useState)({});
    const [colour, setColour] = (0,react.useState)();
    const [selectedVariant, setSelectedVariant] = (0,react.useState)(null);
    const device = hooks_useViewport();
    const { Name: name , productId , imageUrl: image , priceInfo , productInventoryInfo  } = productSwatche;
    const personaPriceList = getPersonaPriceDetails(dataInput);
    (0,react.useEffect)(()=>{
        getGridItems();
        return ()=>{
            setProductSwatche({});
            setLoading("loading");
        };
    }, []);
    (0,react.useEffect)(()=>{
        updateImageUrl();
        return ()=>{
            setValidUrl({});
        };
    }, [
        productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl
    ]);
    const updateImageUrl = async ()=>{
        if (productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl) {
            const res = await isImgUrlValid(productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl);
            if (res) {
                setValidUrl({
                    status: "success"
                });
            } else {
                setValidUrl({
                    status: "failed"
                });
            }
        } else {
            setValidUrl({
                status: "failed"
            });
        }
    };
    const getGridItems = async ()=>{
        setLoading("loading");
        const res = await dataPromise;
        if (res) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            const { Name , productId , skuId , data , productIdKey , data: list , activeItem  } = res;
            const imageUrl = data === null || data === void 0 ? void 0 : (ref = data.colorData) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.imgUrl;
            const priceInfo = (ref3 = list === null || list === void 0 ? void 0 : (ref2 = list.colorData) === null || ref2 === void 0 ? void 0 : ref2.filter((item)=>item.id === activeItem)) === null || ref3 === void 0 ? void 0 : ref3[0];
            const productInventoryInfo = (ref5 = list === null || list === void 0 ? void 0 : (ref4 = list.varientDetails) === null || ref4 === void 0 ? void 0 : ref4.filter((item)=>item.sku === activeItem)) === null || ref5 === void 0 ? void 0 : ref5[0];
            setProductSwatche({
                Name,
                productId,
                skuId,
                imageUrl,
                productIdKey,
                priceInfo,
                productInventoryInfo
            });
            if (list) {
                const getSwatches = list["varientDetails"];
                const filterSwatch = getSwatches === null || getSwatches === void 0 ? void 0 : getSwatches.filter((val)=>val["swatch"] != "swatch_NA");
                const colorArray = personaPriceList.map((item)=>{
                    const matchItem = Object.values(filterSwatch).find((element)=>item.sku === element.sku);
                    if (matchItem) return {
                        ...item,
                        ...matchItem
                    };
                    else return item;
                });
                setColour(colorArray);
            }
            setLoading("loaded");
        }
    };
    if (loading != "loaded") return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingGrid, {
        isListExtend: isListExtend
    });
    const colorSwatchDefaultImg = (e)=>{
        e.target.src = swatch_missing/* default.src */.Z.src;
    };
    const colorCount = isListExtend && ((device === null || device === void 0 ? void 0 : device.isLargeScreen) || (device === null || device === void 0 ? void 0 : device.isExtraLargeScreen)) ? 7 : 5;
    let extraColor;
    if ((colour === null || colour === void 0 ? void 0 : colour.length) > colorCount) {
        extraColor = (colour === null || colour === void 0 ? void 0 : colour.length) - colorCount;
    }
    let marginStyle = "";
    if ((colour === null || colour === void 0 ? void 0 : colour.length) > 0) {
        marginStyle = "mb-8";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card",
        onClick: ()=>{
            showPopup(productId);
        },
        "data-testid": "grid-card",
        onKeyDown: ()=>{
            showPopup(productId);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "thumb-size ".concat(isListExtend ? "grid-fullwidth" : ""),
                children: (validUrl === null || validUrl === void 0 ? void 0 : validUrl.status) === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "loading-spinner border-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "shimmer-loading__image shimmer"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "card-img-top",
                    src: validUrl.status === "success" ? image : coming_soon.src,
                    alt: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-bodys grid ".concat((colour === null || colour === void 0 ? void 0 : colour.length) <= 0 ? "mt-3" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-information",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "color-variants ".concat(marginStyle),
                            children: [
                                (ref = colour === null || colour === void 0 ? void 0 : colour.slice(0, colorCount)) === null || ref === void 0 ? void 0 : ref.map((item)=>item["swatch"] !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "other_color",
                                        onMouseEnter: ()=>setSelectedVariant(item),
                                        onMouseLeave: ()=>setSelectedVariant(null),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            width: "20px",
                                            height: "20px",
                                            className: "img_variant_color",
                                            src: constants["default"].COLOR_FILE_URL + item["swatch"],
                                            alt: item["name"],
                                            onError: (e)=>colorSwatchDefaultImg(e),
                                            title: selectedVariant ? selectedVariant[0] : item["name"]
                                        })
                                    }, item["swatch"]) : null),
                                extraColor ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: "extra-color",
                                    children: [
                                        "+",
                                        extraColor
                                    ]
                                }) : null
                            ]
                        }),
                        (selectedVariant ? selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.discontinued : productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "fs-13 fw-600 tag-discontinue discontinued mb-5 label-discontinued",
                            children: "Discontinued"
                        }) : null,
                        (selectedVariant ? !(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.discontinued) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isStock) === "false" : (productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.isStock) === "false" && (productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued) === false) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "fs-13 fw-600 tag-discontinue mb-5 outof-stoke label-discontinued ",
                            children: "out of stock"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "card-model",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "card-text fw-400 model-number card-product-title text-capitalize mb-5",
                                    children: name === null || name === void 0 ? void 0 : name.toLowerCase()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "card-text fw-400 text-capitalize sku_product-description mb-5 ".concat(device.isSmallScreen ? "my-1" : ""),
                                    children: selectedVariant ? selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.customerSku : priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.value
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "card-text fw-400 text-capitalize sku-price",
                                    children: [
                                        selectedVariant ? (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.currencySign) + (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.price) : (priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.currencySign) + (priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.price),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sku-price mx-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("del", {
                                                children: selectedVariant ? (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.currencySign) + (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.pricelist) : (priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.currencySign) + (priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.pricelist)
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var GridAndListPanel_GridView = (GridView);

;// CONCATENATED MODULE: ./public/scout_icon/dummy_image.jpg
/* harmony default export */ var dummy_image = ({"src":"/_next/static/media/dummy_image.09e12036.jpg","height":800,"width":800,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAgACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAArYP/xAAXEAEAAwAAAAAAAAAAAAAAAAASACJB/9oACAEBAAE/ALLDP//EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQIBAT8Af//EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQMBAT8Af//Z","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/ListView/LoadingCard/index.js



const ListCardLoading = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "card d-flex load-widgets border-active flex-row justify-content-between mt-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "d-flex flex-row justify-content-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "thumb-list loading-animation shimmer ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: dummy_image === null || dummy_image === void 0 ? void 0 : dummy_image.src,
                        alt: "loading"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "width-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex",
                            children: [
                                Array.from({
                                    length: 5
                                }, (val, index)=>index + 1).map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        class: "shimmer-loading__para shimmer width-20"
                                    }, val)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: " width-16 loading-part mx-1 shimmer-loading__para shimmer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex flex-column justify-content-start pt-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: "shimmer-loading__para shimmer width-191 loading-part"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: "shimmer-loading__para shimmer width-102 loading-part"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            class: "shimmer-loading__para shimmer width-15 loading-part"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            class: "shimmer-loading__para shimmer width-15 mx-3 loading-part"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var LoadingCard = (ListCardLoading);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/ListView/index.js









const ListView = (props)=>{
    var ref;
    const { dataPromise , showPopup , isListExtend , dataInput  } = props;
    const [validUrl, setValidUrl] = (0,react.useState)({
        status: "loading"
    });
    const [loading, setLoading] = (0,react.useState)("notStarted");
    const [productSwatche, setProductSwatche] = (0,react.useState)({});
    const device = hooks_useViewport();
    const [colour, setColour] = (0,react.useState)();
    const [selectedVariant, setSelectedVariant] = (0,react.useState)(null);
    const { Name: name , productId , imageUrl: image , priceInfo , productInventoryInfo  } = productSwatche;
    const personaPriceList = getPersonaPriceDetails(dataInput);
    (0,react.useEffect)(()=>{
        getListData();
    }, []);
    (0,react.useEffect)(()=>{
        updateImgUrl();
    }, [
        productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl
    ]);
    const updateImgUrl = async ()=>{
        if (productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl) {
            const res = await isImgUrlValid(productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl);
            if (res) {
                setValidUrl({
                    status: "success"
                });
            } else {
                setValidUrl({
                    status: "failed"
                });
            }
        } else {
            setValidUrl({
                status: "failed"
            });
        }
    };
    const getListData = async ()=>{
        var ref, ref1, ref2, ref3, ref4;
        setLoading("loading");
        const res = await dataPromise;
        const { Name , productId , productIdKey , data: list , activeItem  } = res;
        const imageUrl = (ref = list === null || list === void 0 ? void 0 : list.colorData[0]) === null || ref === void 0 ? void 0 : ref.imgUrl;
        const priceInfo = (ref2 = list === null || list === void 0 ? void 0 : (ref1 = list.colorData) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>item.id === activeItem)) === null || ref2 === void 0 ? void 0 : ref2[0];
        const productInventoryInfo = (ref4 = list === null || list === void 0 ? void 0 : (ref3 = list.varientDetails) === null || ref3 === void 0 ? void 0 : ref3.filter((item)=>item.sku === activeItem)) === null || ref4 === void 0 ? void 0 : ref4[0];
        setProductSwatche({
            Name,
            productId,
            imageUrl,
            productIdKey,
            priceInfo,
            productInventoryInfo
        });
        if (res === null || res === void 0 ? void 0 : res.data) {
            const getSwatches = list === null || list === void 0 ? void 0 : list.varientDetails;
            const filterSwatch = getSwatches.filter((val)=>val["swatch"] != "swatch_NA");
            const colorArray = personaPriceList.map((item)=>{
                const matchItem = Object.values(filterSwatch).find((element)=>item.sku === element.sku);
                if (matchItem) return {
                    ...item,
                    ...matchItem
                };
                else return item;
            });
            setColour(colorArray);
        }
        setLoading("loaded");
    };
    if (loading != "loaded") return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingCard, {});
    const colorCount = 5;
    let extraColor;
    if ((colour === null || colour === void 0 ? void 0 : colour.length) > colorCount) {
        extraColor = (colour === null || colour === void 0 ? void 0 : colour.length) - colorCount;
    }
    let marginStyle;
    let flexDirection;
    const forMediumScreen = (device === null || device === void 0 ? void 0 : device.isMediumScreen) && !isListExtend;
    if (forMediumScreen) {
        marginStyle = "mx-0";
        flexDirection = "flex-column";
    } else if ((colour === null || colour === void 0 ? void 0 : colour.length) > 1) {
        if (device === null || device === void 0 ? void 0 : device.isExtraSmallScreen) {
            marginStyle = "ml-0";
        } else {
            marginStyle = "ml-10 tag-discontinue-position";
        }
    }
    const colorSwatchDefaultImg = (e)=>{
        e.target.src = swatch_missing/* default.src */.Z.src;
    };
    const forAllSmallScreen = device.isMediumScreen || (device === null || device === void 0 ? void 0 : device.isSmallScreen) || (device === null || device === void 0 ? void 0 : device.isExtraSmallScreen);
    const skuPriceClass = isListExtend && !device.isMediumScreen ? "justify-content-end w-50" // mx-auto
     : !isListExtend && device.isMediumScreen ? "mx-0 p-0 mt-5" : "ml-2 px-1";
    let titleAlignCenter = "";
    if (isListExtend && (device.isExtraLargeScreen || device.isLargeScreen)) {
        if (!(productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued) && !((productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.isStock) === "false" && (productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued) === false)) {
            titleAlignCenter = true;
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "card border-active list-section",
        onClick: ()=>{
            showPopup(productId);
        },
        "data-testid": "list-card",
        onKeyDown: ()=>{
            showPopup(productId);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "card-bodys d-flex justify-content-between",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "d-flex w-100 flex-grow-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "thumb-list",
                        children: (validUrl === null || validUrl === void 0 ? void 0 : validUrl.status) === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "loading-spinner",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "shimmer-loading__image shimmer"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            width: "60px",
                            height: "60px",
                            className: "card-img",
                            src: validUrl.status === "success" ? image : coming_soon === null || coming_soon === void 0 ? void 0 : coming_soon.src,
                            alt: name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex justify-content-between w-100 flex-grow-1 \n                ".concat(forAllSmallScreen ? "flex-column" : "", "\n                ").concat(isListExtend && !(device === null || device === void 0 ? void 0 : device.isMediumScreen) ? "flex-row ms-4" : "flex-column", " pt-2 pb-2"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex flex-column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "color-variants list-color ".concat(forMediumScreen ? "d-block" : "color-parts"),
                                        children: [
                                            (colour === null || colour === void 0 ? void 0 : colour.length) > 1 ? (ref = colour === null || colour === void 0 ? void 0 : colour.slice(0, colorCount)) === null || ref === void 0 ? void 0 : ref.map((item)=>{
                                                return (item === null || item === void 0 ? void 0 : item.swatch) !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: "other_color",
                                                    onMouseEnter: ()=>setSelectedVariant(item),
                                                    onMouseLeave: ()=>setSelectedVariant(null),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        width: "20px",
                                                        height: "20px",
                                                        className: "img_variant_color",
                                                        src: constants["default"].COLOR_FILE_URL + item["swatch"],
                                                        alt: item["name"],
                                                        onError: (e)=>colorSwatchDefaultImg(e),
                                                        title: selectedVariant ? selectedVariant[0] : item["name"]
                                                    })
                                                }, item["swatch"]) : "";
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: titleAlignCenter ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title-center-align"
                                                }) : ""
                                            }),
                                            extraColor ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: "extra-color",
                                                children: [
                                                    "+",
                                                    extraColor
                                                ]
                                            }) : "",
                                            (selectedVariant ? selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.discontinued : productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: "fs-13 fw-600 tag-discontinue discontinued label-discontinued ".concat(marginStyle),
                                                children: "Discontinued"
                                            }) : "",
                                            (selectedVariant ? !(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.discontinued) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isStock) === "false" : (productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.isStock) === "false" && (productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued) === false) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: "fs-13 fw-600 tag-discontinue outof-stoke label-discontinued ".concat(marginStyle, " "),
                                                children: "out of stock"
                                            }) : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex align-items-center justify-content-between mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                fontSize: 18,
                                                className: "card-text fw-400 tablet-view-padding ".concat(isListExtend ? "model-name-list " : "model-name list-items", " text-capitalize"),
                                                children: name === null || name === void 0 ? void 0 : name.toLowerCase()
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "list right-screen add-to-cart",
                                                children: "Add"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex card-text fw-400 align-items-center list-details list-fullwidth-tab ".concat(isListExtend ? "list-fullwidth" : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "model-name d-flex ".concat(flexDirection, " ").concat(isListExtend && !device.isMediumScreen ? "justify-content-end w-75" // mx-auto
                                         : ""),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                fontSize: 14,
                                                className: "sku-name",
                                                children: selectedVariant ? selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.customerSku : priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.value
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                fontSize: 14,
                                                className: "model-prices d-flex  \n                      ".concat(skuPriceClass),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sku_product",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("del", {
                                                            children: selectedVariant ? (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.currencySign) + (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.pricelist) : (priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.currencySign) + (priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.pricelist)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "model-name-price ml-2 px-1",
                                                        children: selectedVariant ? (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.currencySign) + (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.price) : (priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.currencySign) + (priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.price)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "list add-to-cart",
                                        children: "Add"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var GridAndListPanel_ListView = (ListView);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/ViewController/index.js





const ViewController = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { partController , isListView , isListExtend , showPopup , visibleData , title , sku  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditional_Conditional, {
                show: isListView,
                children: (ref2 = partController === null || partController === void 0 ? void 0 : (ref = partController.actions) === null || ref === void 0 ? void 0 : (ref1 = ref.get) === null || ref1 === void 0 ? void 0 : ref1.firstEntries(visibleData)) === null || ref2 === void 0 ? void 0 : ref2.map((input)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_ListView, {
                        dataInput: input,
                        dataPromise: input.ctApiPromise,
                        showPopup: showPopup,
                        isListExtend: isListExtend,
                        title: title,
                        sku: sku
                    }, input.key))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditional_Conditional, {
                show: !isListView,
                children: (ref5 = partController === null || partController === void 0 ? void 0 : (ref3 = partController.actions) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.get) === null || ref4 === void 0 ? void 0 : ref4.firstEntries(visibleData)) === null || ref5 === void 0 ? void 0 : ref5.map((input)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_GridView, {
                        dataInput: input,
                        dataPromise: input.ctApiPromise,
                        showPopup: showPopup,
                        isListExtend: isListExtend,
                        title: title,
                        sku: sku
                    }, input.key))
            })
        ]
    });
};
/* harmony default export */ var GridAndListPanel_ViewController = (ViewController);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/index.js










const GridAndListPanel = (props)=>{
    var ref, ref1;
    const { partsList , setIsListExtend , isListExtend , title , limit =6 , showPopup , partController , sku  } = props;
    const [listView, setlistView] = (0,react.useState)(false);
    const [trigger, callTrigger] = hooks_useTrigger();
    const device = hooks_useViewport();
    const loadCount = (partsList === null || partsList === void 0 ? void 0 : partsList.length) < limit ? partsList === null || partsList === void 0 ? void 0 : partsList.length : limit;
    const visibleCount = (ref = partController.actions.get.firstEntries()) === null || ref === void 0 ? void 0 : ref.length;
    const totalCount = partsList === null || partsList === void 0 ? void 0 : partsList.length;
    const [visibleData, setVisibleData] = (0,react.useState)(loadCount);
    (0,react.useEffect)(()=>callTrigger(), [
        title
    ]);
    (0,react.useEffect)(()=>{
        if (visibleCount < limit) partController.actions.fetchCTAny(loadCount);
    }, [
        trigger
    ]);
    const scrollToTop = ()=>{
        const ele = document.querySelector(".right-panel");
        if (ele) {
            ele.scrollIntoView({
                behaviour: "smooth"
            });
        }
    };
    const loadMoreitems = (e)=>{
        setVisibleData(visibleData + loadCount);
        partController.actions.fetchCTAny(visibleData);
    };
    const isDesktop = device.isLargeScreen || device.isExtraLargeScreen || device.isMediumScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-list-viewer h-100",
        "data-testid": "right-panel-wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            fluid: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    className: "right-panel",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                        className: "d-flex justify-content-between align-items-center",
                        children: [
                            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_ToggleView, {
                                listView,
                                setlistView,
                                device,
                                title,
                                sku
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-flex align-items-center justify-content-center",
                                children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: ()=>{
                                        setIsListExtend((state)=>!state);
                                    },
                                    "data-testid": "expand-button",
                                    className: "expand-button btn-expand border-0 d-flex align-items-center justify-content-center list-view-icons",
                                    children: [
                                        isListExtend ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCollapse, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconExpandGrid, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tool-tip-custom bottom",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: !isListExtend ? "Expand" : "Exit Expand"
                                            })
                                        })
                                    ]
                                }) : null
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: "flex-column gird-content",
                    children: [
                        isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            className: "mt-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading_Heading, {
                                level: 3,
                                fontSize: 26,
                                className: "heading-grid",
                                fontWeight: 300,
                                children: title
                            })
                        }) : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex flex-row align-items-center justify-content-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "total_item",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "total-count fw-400 ".concat(isListExtend ? "full-screen-view" : "small-screen-view"),
                                            children: [
                                                (partsList === null || partsList === void 0 ? void 0 : partsList.length) || 0,
                                                " Results"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_SortDropdown, {
                                        partController,
                                        visibleData,
                                        title,
                                        sku,
                                        setlistView,
                                        listView,
                                        isListExtend
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            className: "d-flex align-items-center flex-column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "list-items ".concat(listView ? "d-flex justify-content-between flex-column" : "thumbnail-items ".concat(device.isDesktop ? "full-screens" : "")),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_ViewController, {
                                            partController,
                                            isListView: listView,
                                            isListExtend,
                                            showPopup,
                                            visibleData,
                                            title,
                                            sku
                                        }),
                                        (ref1 = Array.from({
                                            length: 6
                                        }, (val, index)=>index + 1)) === null || ref1 === void 0 ? void 0 : ref1.map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "card empty-card"
                                            }, val))
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "load-more d-flex align-items-center flex-column w-100",
                                    children: visibleData < totalCount ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: loadMoreitems,
                                        className: "load-more-button fs-18 fw-400 w-100",
                                        children: "Load More"
                                    }) : null
                                }),
                                totalCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "back-to-top",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: ()=>scrollToTop(),
                                            className: "mx-2",
                                            children: "Back to Top"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToTop, {})
                                    ]
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v2_GridAndListPanel = (GridAndListPanel);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/SelectedFileView/DesktopView/index.js








const DesktopView = (props)=>{
    const { selectedFile , fullscreen , expandHandler , partsList , setIsListExtend , isListExtend , title , showPopup , popupModal , setModal , productId , partController , sku , loading , analytics , setWidthSize , widthSize  } = props;
    if (loading.error) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorFallBack, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    right: popupModal && fullscreen ? widthSize : 0 + "px",
                    width: popupModal && fullscreen ? "auto" : ""
                },
                className: "".concat(isListExtend ? "" : "fullscreen-extend", " left"),
                children: !(loading === null || loading === void 0 ? void 0 : loading.status) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PartsDiagramViewer, {
                    expandHandler: expandHandler,
                    fullscreen: fullscreen,
                    showPopup: showPopup,
                    selectedFile: selectedFile,
                    partController: partController,
                    sku: sku,
                    title: title
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderSpinner, {})
            }),
            !(loading === null || loading === void 0 ? void 0 : loading.error) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(isListExtend ? "fullscreen-extend" : "", " fullscreen-right h-100"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_GridAndListPanel, {
                    partsList: partsList,
                    setIsListExtend: setIsListExtend,
                    isListExtend: isListExtend,
                    title: title,
                    showPopup: showPopup,
                    partController: partController,
                    sku: sku
                })
            }) : "",
            popupModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_DetailPopUp, {
                productId: productId,
                setModal: setModal,
                partController: partController,
                sku: sku,
                title: title,
                analytics: analytics,
                fullscreen: fullscreen,
                setWidthSize: setWidthSize
            }) : ""
        ]
    });
};
DesktopView.propTypes = {
    widthSize: (prop_types_default()).number.isRequired,
    setWidthSize: (prop_types_default()).func.isRequired
};
/* harmony default export */ var SelectedFileView_DesktopView = (DesktopView);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tab.js + 1 modules
var Tab = __webpack_require__(73192);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tabs.js + 21 modules
var Tabs = __webpack_require__(83109);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/SelectedFileView/MobileView/index.js











const MobileView = (props)=>{
    const { expandHandler , partsList , setIsListExtend , isListExtend , title , showPopup , popupModal , setModal , productId , selected , tabsActive , panelState , onClose , partController , sku , prefeedbackController , loading , analytics , setWidthSize  } = props;
    const { isDesktop  } = hooks_useViewport();
    (0,react.useEffect)(()=>prefeedbackController(false), []);
    const selectionChange = (selection)=>{
        onClose(false);
        prefeedbackController(selection == "parts");
    };
    if (loading.error) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorFallBack, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-tabs d-flex flex-column w-100 ".concat(tabsActive == "parts" ? "parts-section" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                    defaultActiveKey: "diagram",
                    className: "mb-3 mobile-view",
                    onSelect: (selection)=>selectionChange(selection),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                            eventKey: "diagram",
                            title: "Diagram",
                            className: "tab-diagram",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(isListExtend ? "" : "fullscreen-extend", " left"),
                                children: !(loading === null || loading === void 0 ? void 0 : loading.status) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PartsDiagramViewer, {
                                    expandHandler: expandHandler,
                                    fullscreen: panelState,
                                    selectedFile: selected,
                                    showPopup: showPopup,
                                    partController: partController,
                                    sku: sku,
                                    title: title
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderSpinner, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                            eventKey: "parts",
                            title: "Parts",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(isListExtend ? "fullscreen-extend" : "", " fullscreen-right h-100"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_GridAndListPanel, {
                                    partsList: partsList,
                                    setIsListExtend: setIsListExtend,
                                    isListExtend: isListExtend,
                                    title: title,
                                    showPopup: showPopup,
                                    partController: partController,
                                    sku: sku
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-popup ".concat(!isDesktop && popupModal ? "active" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_DetailPopUp, {
                    productId: productId,
                    setModal: setModal,
                    partController: partController,
                    sku: sku,
                    title: title,
                    analytics: analytics,
                    setWidthSize: setWidthSize
                })
            })
        ]
    });
};
MobileView.propTypes = {
    setWidthSize: (prop_types_default()).func.isRequired
};
/* harmony default export */ var SelectedFileView_MobileView = (MobileView);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/SelectedFileView/index.js





const SelectedFileView = (props)=>{
    const { selectedFile , expandHandler , partsList , setIsListExtend , isListExtend , title , showPopup , popupModal , setModal , productId , selected , tabsActive , panelState , onClose , sku , prefeedbackController , loading , analytics  } = props;
    const [partsState, dispatch] = (0,react.useReducer)(partReducer, {
        parts: []
    });
    const [widthSize, setWidthSize] = (0,react.useState)(0);
    const partsActions = getActions(partsState, dispatch);
    (0,react.useEffect)(()=>partController.actions.initPartsList(selected), [
        selected
    ]);
    let isDesktop;
    const screenWidth = window.innerWidth;
    if (screenWidth > 812) {
        isDesktop = true;
    }
    const partController = {
        state: partsState,
        actions: partsActions
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedFileView_MobileView, {
            expandHandler: expandHandler,
            panelState: panelState,
            showPopup: showPopup,
            selectedFile: selectedFile,
            partsList: partsList,
            setIsListExtend: setIsListExtend,
            isListExtend: isListExtend,
            title: title,
            productId: productId,
            tabsActive: tabsActive,
            setModal: setModal,
            popupModal: popupModal,
            selected: selected,
            onClose: onClose,
            sku: sku,
            partController: partController,
            prefeedbackController: prefeedbackController,
            loading: loading,
            analytics: analytics,
            setWidthSize: setWidthSize
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedFileView_DesktopView, {
                expandHandler: expandHandler,
                fullscreen: panelState,
                showPopup: showPopup,
                selectedFile: selectedFile,
                partsList: partsList,
                setIsListExtend: setIsListExtend,
                isListExtend: isListExtend,
                title: title,
                productId: productId,
                setModal: setModal,
                popupModal: popupModal,
                selected: selected,
                partController: partController,
                sku: sku,
                loading: loading,
                analytics: analytics,
                setWidthSize: setWidthSize,
                widthSize: widthSize
            })
        })
    });
};
/* harmony default export */ var v2_SelectedFileView = (SelectedFileView);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartViewerModal/index.js







const PartsViewerModal = (props)=>{
    var ref;
    const { files , fileMap , title , sku , skuImage , prefeedbackController , setParts , selectedFile , loading , analytics ={
        page: "na"
    } , setPartsHeight  } = props;
    const [selected, setSelected] = (0,react.useState)(selectedFile);
    const [selectedPart, setSelectedPart] = (0,react.useState)("");
    const [isListExtend, setIsListExtend] = (0,react.useState)(false);
    const [panelState, setPanelState] = (0,react.useState)(false);
    const device = hooks_useViewport();
    const [popupModal, setPopupModal] = (0,react.useState)(false);
    const [tabsActive, setTabsActive] = (0,react.useState)("");
    let initialIndex;
    const isActive = (item)=>{
        return (item === null || item === void 0 ? void 0 : item.FileName) == (selected === null || selected === void 0 ? void 0 : selected.FileName);
    };
    for(let i = 0; i <= (files === null || files === void 0 ? void 0 : files.length) - 1; i++){
        var ref1;
        if (((ref1 = files[i]) === null || ref1 === void 0 ? void 0 : ref1.FileName) === (selected === null || selected === void 0 ? void 0 : selected.FileName)) {
            initialIndex = i;
        }
    }
    const getFileTitle = (name)=>{
        return (fileMap === null || fileMap === void 0 ? void 0 : fileMap[name]) === undefined ? name === null || name === void 0 ? void 0 : name.replace(/.svg/i, "") : fileMap === null || fileMap === void 0 ? void 0 : fileMap[name];
    };
    const showPopup = function(selectedItem) {
        let popupFlag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        const getSelectedItems = selected === null || selected === void 0 ? void 0 : selected.Parts.filter((val)=>{
            return (val === null || val === void 0 ? void 0 : val.Cod) === selectedItem;
        });
        if (getSelectedItems.length !== 0) {
            setPopupModal(popupFlag);
            setSelectedPart(selectedItem);
        } else {
            setPopupModal(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !(loading === null || loading === void 0 ? void 0 : loading.error) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal-fullscreen modal-container ".concat(device.isSmallScreen ? "mobile-viewer" : "", "  ").concat(panelState ? "fullscreen-viewer" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedFileView_FileSelection, {
                    files: files,
                    getFileTitle: getFileTitle,
                    isActive: isActive,
                    setSelected: setSelected,
                    setPopupModal: setPopupModal,
                    title: title,
                    sku: sku,
                    skuImage: skuImage,
                    setParts: setParts,
                    panelState: panelState,
                    initialIndex: initialIndex,
                    setPartsHeight: setPartsHeight
                })
            }) : "",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "parts-modal-wrapper modal_content ".concat(device.isSmallScreen ? "align-items-start" : "", "  ").concat(panelState ? "fullscreen-viewer" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ErrorBoundary, {
                    FallBackComponent: ErrorFallBack,
                    params: {
                        title: getFileTitle(selected === null || selected === void 0 ? void 0 : selected.FileName)
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_SelectedFileView, {
                        expandHandler: ()=>setPanelState((state)=>!state),
                        panelState: panelState,
                        showPopup: showPopup,
                        selectedFile: selected,
                        partsList: selected === null || selected === void 0 ? void 0 : selected.Parts,
                        setIsListExtend: setIsListExtend,
                        isListExtend: isListExtend,
                        title: getFileTitle(selected === null || selected === void 0 ? void 0 : selected.FileName),
                        productId: selectedPart,
                        tabsActive: tabsActive,
                        setModal: setPopupModal,
                        popupModal: popupModal,
                        selected: selected,
                        onClose: setTabsActive,
                        sku: title === null || title === void 0 ? void 0 : (ref = title.props) === null || ref === void 0 ? void 0 : ref.sku,
                        prefeedbackController: prefeedbackController,
                        loading: loading,
                        analytics: analytics
                    })
                }, selected === null || selected === void 0 ? void 0 : selected.FileName)
            })
        ]
    });
};
/* harmony default export */ var PartViewerModal = (PartsViewerModal);

// EXTERNAL MODULE: ./components/PartsViewer/v2/partviewer.module.scss
var partviewer_module = __webpack_require__(22222);
var partviewer_module_default = /*#__PURE__*/__webpack_require__.n(partviewer_module);
// EXTERNAL MODULE: ./utils/index.js
var utils_0 = __webpack_require__(20558);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartsViewer.jsx












const PartsViewer = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { page ="" , analyticsCustomData =null , onClose =()=>{} , showModal =false , productId ="" , fileMap =[] , partId =""  } = props;
    const [parts, setParts] = (0,react.useState)("");
    const [partsheight, setPartsHeight] = (0,react.useState)("");
    const [trigger, triggerAction] = hooks_useTrigger();
    const [loading, setLoading] = (0,react.useState)({
        status: true,
        error: false
    });
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        const metaVal = "width=device-width, initial-scale=1.0";
        if (showModal) {
            var ref, ref1;
            (0,utils_0.updateMetaContent)("viewport", "".concat(metaVal, ", maximum-scale=1.0, user-scalable=false"));
            (0,helper.preventBodyScroll)(true);
            (ref = document.querySelector("mavenoid-assistant")) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.add("mavenoid-suppress");
            document.addEventListener("touchmove", handlerViewport, false);
        }
        return ()=>{
            var ref, ref1;
            (ref = document.querySelector("mavenoid-assistant")) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.remove("mavenoid-suppress");
            document.removeEventListener("touchmove", handlerViewport);
            (0,utils_0.updateMetaContent)("viewport", metaVal);
        };
    }, [
        showModal
    ]);
    (0,react.useEffect)(()=>{
        if (productId && fileMap) {
            const obj = {};
            fileMap.forEach((item)=>{
                obj[item.id] = item.title;
            });
            productInfo(obj);
        }
    }, [
        productId
    ]);
    const handlerViewport = (event)=>{
        if ((event === null || event === void 0 ? void 0 : event.scale) !== 1) {
            event.preventDefault();
        }
    };
    const productInfo = async (obj)=>{
        const resp = await dispatch((0,pdpSlice.getPartList)({
            productId
        })).unwrap();
        if (resp === null || resp === void 0 ? void 0 : resp.SVGFiles) {
            const { Info , SVGFiles  } = resp;
            const diagramFiles = fileMap.map((val)=>{
                const getfile = SVGFiles === null || SVGFiles === void 0 ? void 0 : SVGFiles.filter((v)=>{
                    return (v === null || v === void 0 ? void 0 : v.FileName) === (val === null || val === void 0 ? void 0 : val.id);
                });
                return {
                    ...getfile === null || getfile === void 0 ? void 0 : getfile[0],
                    ...val
                };
            });
            const activePart = diagramFiles === null || diagramFiles === void 0 ? void 0 : diagramFiles.filter((val)=>val.FileName === partId);
            const selectedFile = activePart.length !== 0 ? activePart[0] : diagramFiles[0];
            const priceList = await getProjectionPartListData(selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.Parts);
            selectedFile.prices = priceList;
            setParts({
                fileMap: obj,
                partsInfo: {
                    Info,
                    SVGFiles: diagramFiles
                },
                selectedFile
            });
            setLoading({
                status: false,
                error: false
            });
        } else setLoading({
            status: false,
            error: true
        });
    };
    const closeModal = ()=>{
        (0,helper.preventBodyScroll)(false);
        onClose();
    };
    const getPartDiagramCloseEventInfo = JSON.stringify({
        eventAction: page + ":modal:interactive parts diagram:close",
        eventName: page + ":modal:interactive parts diagram:close",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: page,
        internalLinkType: page + ":close",
        internalLinkZoneName: page + ":modal:interactive parts diagram",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
    let text1;
    let text2;
    let title;
    if ((parts === null || parts === void 0 ? void 0 : (ref = parts.partsInfo) === null || ref === void 0 ? void 0 : ref.Info) !== undefined) {
        var ref6, ref7, ref8, ref9;
        text1 = parts === null || parts === void 0 ? void 0 : (ref6 = parts.partsInfo) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Info) === null || ref7 === void 0 ? void 0 : ref7["Product Name"];
        text2 = parts === null || parts === void 0 ? void 0 : (ref8 = parts.partsInfo) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.Info) === null || ref9 === void 0 ? void 0 : ref9["Short Description"];
        title = text1.replace(new RegExp(text2, "g"), "");
    }
    const prefeedbackController = ()=>{};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        show: showModal,
        closeButtonAnalytics: getPartDiagramCloseEventInfo,
        analyticsCustomData: analyticsCustomData || null,
        className: "partviwer-modal ".concat((partviewer_module_default()).PartDiagramViewer),
        fullscreen: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "close-btns",
                onClick: closeModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "partviewer-modal-container part-".concat(partsheight, " ").concat(!parts ? "loading-text" : ""),
                children: !loading.status ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PartViewerModal, {
                    trigger: trigger,
                    triggerAction: triggerAction,
                    files: parts === null || parts === void 0 ? void 0 : (ref1 = parts.partsInfo) === null || ref1 === void 0 ? void 0 : ref1.SVGFiles,
                    fileMap: parts === null || parts === void 0 ? void 0 : parts.fileMap,
                    prefeedbackController: prefeedbackController,
                    skuImage: parts === null || parts === void 0 ? void 0 : (ref2 = parts.partsInfo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Info) === null || ref3 === void 0 ? void 0 : ref3.Thumbnail,
                    title: title,
                    sku: parts === null || parts === void 0 ? void 0 : (ref4 = parts.partsInfo) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Info) === null || ref5 === void 0 ? void 0 : ref5.Cod,
                    setParts: setParts,
                    selectedFile: parts === null || parts === void 0 ? void 0 : parts.selectedFile,
                    loading: loading,
                    analytics: {
                        page: page
                    },
                    setPartsHeight: setPartsHeight
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderSpinner, {})
            })
        ]
    });
};
/* harmony default export */ var v2_PartsViewer = (PartsViewer);


/***/ }),

/***/ 9670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q3": function() { return /* binding */ getListOfRequiredSkus; },
/* harmony export */   "X_": function() { return /* binding */ getZipCodes; },
/* harmony export */   "fh": function() { return /* binding */ getProductDataFromSkuIds; },
/* harmony export */   "o": function() { return /* binding */ getProductInventory; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19514);
/* harmony import */ var _utils_ApiUtil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51666);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96301);





const getListOfParamsToFetch = (persona)=>{
    const fl = [
        "id",
        "slug_s",
        "productName_s",
        "masterSKU_s",
        "sku_s",
        "Product_Category",
        "ProductBrandName_s",
        "productImages.url_s",
        "productImages.url_ss",
        "SKUColorSwatchFilename_s",
        "SKUColorSwatchFilename_ss",
        "ProductDescriptionProductShort_s",
        "priceStartingAt.".concat(persona, "_d"),
        "discountedPriceStartingAt.".concat(persona, "_d"),
        "priceList.".concat(persona, ".saleOffer_s"),
        "Color.SKU.Details_ss",
        "Color.SKU.Details_s",
        "ProductWebFeatures_ss",
        "ProductWebFeatures_s",
        "ProductIsExclusive_s",
        "RegionReleaseforShipment_dt",
        "title_s",
        "ProductNarrativeDescription_s",
        "priceList.".concat(persona, ".finalPrice_d"),
        "CustomerFacingBrand_s",
        "RegionBrandName_s",
        "priceList.".concat(persona, ".discountedPrice_d"),
        "priceList.".concat(persona, ".price_d"),
        "CrossSellRecommendationSKUList_ss",
        "productImages.labelWithUrl_ss"
    ];
    return fl.join(",");
};
const getProductDataFromSkuIds = async function() {
    let persona = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "GST", skus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], lwAppName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var ref;
    if (!skus.length) return;
    const fl = getListOfParamsToFetch(persona);
    const fq = "sku_s:(".concat(skus.map((ele)=>'"'.concat(ele, '"')).join(" "), ")");
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const brand = lwAppName === null || lwAppName === void 0 ? void 0 : lwAppName.toLowerCase();
    var ref2;
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__.apim.get("/search/plp", {
        params: {
            fl,
            q: "*:*",
            fq: [
                fq,
                'language_s:("'.concat(language, '")')
            ],
            collections: brand,
            profilename: "profile_".concat(brand, "_Full_Catalog"),
            rows: (ref2 = skus === null || skus === void 0 ? void 0 : skus.length) !== null && ref2 !== void 0 ? ref2 : 10,
            sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_2__/* .getSessionIdObjWithEpoc */ .o)()
        },
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_4___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
};
const getZipCodes = async (jsonFileUrl)=>await (0,_constants_api__WEBPACK_IMPORTED_MODULE_0__.aemAxiosInstance)({
        url: _constants__WEBPACK_IMPORTED_MODULE_3__.GLOBAL_CONFIGURATION_ENDPOINT,
        params: {
            path: jsonFileUrl
        }
    });
const getListOfRequiredSkus = async function() {
    let persona = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "GST", slug = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", sku = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", lwAppName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var ref;
    const fl = getListOfParamsToFetch(persona);
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const fq = 'sku_s:("'.concat(sku, '")');
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__.apim.post("search/pdp/".concat(slug), {
        fl,
        q: "*:*",
        fq: "".concat(fq, ' AND language_s:("').concat(language, '")'),
        collections: lwAppName,
        profilename: "profile_".concat(lwAppName, "_General"),
        sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_2__/* .getSessionIdObjWithEpoc */ .o)()
    });
};
const getProductInventory = function() {
    let skus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__.apim.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_3__.getStockEndPoint, "/?sku=").concat(skus));
};



/***/ }),

/***/ 32982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19514);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96301);
/* harmony import */ var _public_images_swatch_missing_jpeg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36562);








const ColorSwatch = (props)=>{
    const { type ="" , id ="" , label ="" , name ="" , value ="" , checked =false , color ="" , colorUrl =""  } = props;
    const [config, setConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [swatchUrl, setSwatchUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)().then((config)=>setConfig(config));
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(config)) {
            const assetAccountName = lodash_get__WEBPACK_IMPORTED_MODULE_2___default()(config, "general.scene7AccountName", "PAWEB");
            let swatchUrl = colorUrl ? colorUrl + "?$PDPSwatch_Desk$" : _public_images_swatch_missing_jpeg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
            swatchUrl = swatchUrl.replace("PAWEB", assetAccountName);
            setSwatchUrl(swatchUrl);
        }
    }, [
        config
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "color-swatch",
        title: label,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: type === "selector" ? "radio" : "checkbox",
                id: id,
                name: name,
                value: value,
                checked: checked,
                style: {
                    backgroundColor: color
                },
                onClick: (e)=>props.onClick(e.target.value),
                onChange: (e)=>props.onChange(e),
                "data-testid": "color-swatch-".concat(id !== null && id !== void 0 ? id : "0")
            }),
            type !== "selector" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: id,
                children: label
            }),
            type === "selector" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: "".concat(!colorUrl || colorUrl.includes(_constants_index__WEBPACK_IMPORTED_MODULE_5__.SWATCH_NA) ? "--no-swatch" : ""),
                htmlFor: id,
                children: swatchUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    role: "presentation",
                    src: swatchUrl,
                    alt: "NA"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    role: "presentation",
                    src: _constants_index__WEBPACK_IMPORTED_MODULE_5__.EMPTY_PIXEL,
                    alt: "EMPTY_PIXEL"
                })
            })
        ]
    });
};
ColorSwatch.defaultProps = {
    type: "",
    label: "",
    id: "",
    name: "",
    value: undefined,
    color: "",
    colorUrl: "",
    checked: undefined,
    defaultChecked: false,
    onClick: ()=>{},
    onChange: ()=>{}
};
ColorSwatch.propTypes = {
    type: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    label: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    id: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string) || (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number),
    color: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    colorUrl: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    checked: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    defaultChecked: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func),
    onChange: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func),
    onMouseEnter: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func)
};
/* harmony default export */ __webpack_exports__["default"] = (ColorSwatch);


/***/ }),

/***/ 3372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24400);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55760);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96301);
/* harmony import */ var _components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21531);
/* harmony import */ var _components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6__);







const Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    var ref1;
    const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const errorRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    var _type;
    const [type, setType] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((_type = props.type) !== null && _type !== void 0 ? _type : "text");
    const [toggle, setToggle] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [showList, setShowList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [matchedItem, setMatchedItem] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [selectedListItem, setListItem] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [focus, setFocus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { showError , errorMessage , id , className ="" , placeholder =""  } = props;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (toggle) setType("text");
        else setType("password");
    }, [
        toggle
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (props === null || props === void 0 ? void 0 : props.focus) {
            inputRef.current.focus();
        }
    }, [
        props === null || props === void 0 ? void 0 : props.focus
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showError && errorMessage) {
            errorRef.current.focus();
        }
    }, [
        showError,
        errorMessage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const keyPressEvent = (e)=>{
            const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_5__["default"];
            if (e.keyCode === KEYCODE.TAB && showList) {
                setShowList(false);
            }
        };
        const containerTarget = (e)=>{
            var ref;
            if (showList && !((ref = document.getElementById("".concat(props.id, "-wrapper"))) === null || ref === void 0 ? void 0 : ref.contains(e.target))) setShowList(false);
        };
        window.addEventListener("click", containerTarget);
        document.addEventListener("keydown", keyPressEvent);
        return ()=>{
            document.removeEventListener("keydown", keyPressEvent);
            window.removeEventListener("click", containerTarget);
        };
    }, [
        showList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref, ref1;
        if (((ref = props.value) === null || ref === void 0 ? void 0 : ref.length) > 0 && ((ref1 = props.suggestions) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
            setShowList(true);
            selectListItem();
            setActivedescendant();
        } else setShowList(false);
    }, [
        props.value,
        props.suggestions
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showList) setActivedescendant();
    }, [
        showList
    ]);
    const selectListItem = ()=>{
        const listItems = [
            ...props.suggestions
        ];
        const firstMatchedItem = listItems.find((item)=>{
            if (item === null || item === void 0 ? void 0 : item.includes(props.value)) return item;
        });
        setMatchedItem(firstMatchedItem);
    };
    var _id;
    const setActivedescendant = ()=>{
        var ref;
        return setListItem((_id = (ref = document.getElementById("".concat(props.id, "-list"))) === null || ref === void 0 ? void 0 : ref.childNodes[0].id) !== null && _id !== void 0 ? _id : "");
    };
    const inputClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()("input-field__border", props.disabled ? "--disabled" : null, props.showError ? "--with-error" : null, focus ? "--focused" : null);
    const i18n = {
        show: t("kf.auth.label.show"),
        hide: t("kf.auth.label.hide"),
        resultsText: t("kf.input.aria.resultsText")
    };
    const handleClick = ()=>{
        var ref;
        return (ref = document.getElementById(props.id)) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const handleKeyDown = (e)=>{
        if (showList) {
            const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_5__["default"];
            const ele = [
                ...document.getElementById("".concat(props.id, "-list")).childNodes
            ];
            let index = 0;
            const selectedItem = ele.find((item, i)=>{
                if (item.id === selectedListItem) {
                    index = i;
                    return item;
                }
            });
            switch(e.keyCode){
                case KEYCODE.ESC:
                    setShowList(false);
                    break;
                case KEYCODE.UP:
                    e.preventDefault();
                    if (index > 0) ele.forEach((item, i)=>{
                        if (i === index - 1) {
                            item.classList.add("--hover");
                            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__.smoothScroll)(item);
                            setListItem(item.id);
                        } else item.classList.remove("--hover");
                    });
                    break;
                case KEYCODE.DOWN:
                    e.preventDefault();
                    if (index < ele.length - 1) ele.forEach((item, i)=>{
                        if (i === index + 1) {
                            item.classList.add("--hover");
                            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__.smoothScroll)(item);
                            setListItem(item.id);
                        } else item.classList.remove("--hover");
                    });
                    break;
                case KEYCODE.SPACE:
                    break;
                case KEYCODE.ENTER:
                    selectedItem.click();
                    break;
                default:
                    break;
            }
        }
    };
    var _ariaRequried;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inputFieldWrapper), " ").concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: " input-field ".concat(props.customClass ? props.customClass : ""),
            id: "".concat(props.id, "-wrapper"),
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: inputClasses,
                    children: [
                        props.prefix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "input-field__prefix",
                            children: props.prefix
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "input-field__value",
                            onKeyDown: (e)=>handleKeyDown(e),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    ref: ref !== null && ref !== void 0 ? ref : inputRef,
                                    id: props.id,
                                    type: props.type === "password" ? type : props.type,
                                    value: props.value,
                                    name: props.name,
                                    autoComplete: props.autoComplete ? "on" : "off",
                                    maxLength: props.maxLength,
                                    disabled: props.disabled,
                                    placeholder: placeholder ? placeholder : props.label.replace(/\*/g, ""),
                                    onChange: props.onChange,
                                    onKeyUp: props.onKeyUp,
                                    onKeyDown: props.onKeyDown,
                                    onKeyPress: handleKeyDown,
                                    onFocus: (e)=>{
                                        setFocus(true);
                                        props.onFocus && props.onFocus(e);
                                    },
                                    onBlur: (e)=>{
                                        setFocus(false);
                                        props.onBlur && props.onBlur(e);
                                    },
                                    max: props.max,
                                    min: props.min,
                                    autoFocus: props.autoFocus,
                                    "aria-required": ((_ariaRequried = props.ariaRequried) !== null && _ariaRequried !== void 0 ? _ariaRequried : props.label.indexOf("*") > 0) ? true : false,
                                    "aria-activedescendant": props.autoComplete ? selectedListItem : "undefined",
                                    "aria-readonly": props.readOnly ? "true" : "false",
                                    "aria-owns": "".concat(props.id, "-list"),
                                    // aria-expanded={props.autoComplete ? showList : "undefined"}
                                    "aria-haspopup": props.autoComplete ? "listbox" : "false",
                                    "data-testid": "input"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    htmlFor: props.id,
                                    "aria-hidden": "true",
                                    children: props.label
                                })
                            ]
                        }),
                        props.type === "password" && ((ref1 = props.value) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "input-field__suffix",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                tabIndex: "0",
                                "aria-label": toggle ? "".concat(i18n.hide, " ").concat(props.label) : "".concat(i18n.show, " ").concat(props.label),
                                role: "button",
                                onClick: ()=>setToggle(!toggle),
                                className: "input-field__toggle",
                                children: toggle ? i18n.hide : i18n.show
                            })
                        }),
                        props.suffix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "input-field__suffix",
                            children: props.suffix
                        })
                    ]
                }),
                showList && props.suggestions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    id: "".concat(props.id, "-list"),
                    className: "input-field__suggestions",
                    role: "listbox",
                    "aria-label": i18n.resultsText,
                    children: props.suggestions.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            id: "suggestion-list-item-".concat(i),
                            className: "input-field__list-item ".concat(matchedItem === item ? "--hover" : ""),
                            "aria-selected": selectedListItem === item ? "true" : "false",
                            role: "option",
                            onClick: ()=>props.onSelect(item),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "input-field__list-value",
                                children: item
                            })
                        }, i))
                }),
                showError && errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    ref: errorRef,
                    "aria-live": "polite",
                    role: "alert",
                    id: "".concat(id, "-error"),
                    className: "input-field__error-message",
                    children: errorMessage
                })
            ]
        })
    });
});
Input.displayName = "Input";
Input.defaultProps = {
    label: ""
};
/* harmony default export */ __webpack_exports__["default"] = (Input);


/***/ }),

/***/ 78145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Modal_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
;// CONCATENATED MODULE: ./components/core/FindingModelNumber/v1/analyticsEventType.js
const getEventFor = (type)=>{
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("support:contact")) {
        return "support:contact:form";
    }
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("support:find a service part")) {
        return "support:find-a-service-part";
    }
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("my account:product registration")) {
        return "my account:register offline kohler products:product information";
    }
    var ref;
    return (ref = type === null || type === void 0 ? void 0 : type.subCategory1) !== null && ref !== void 0 ? ref : "";
};


// EXTERNAL MODULE: ./public/icons/close-white.svg
var close_white = __webpack_require__(26693);
// EXTERNAL MODULE: ./public/icons/modal-close.svg
var modal_close = __webpack_require__(55619);
// EXTERNAL MODULE: ./components/core/Modal/Modal.module.scss
var Modal_module = __webpack_require__(43106);
var Modal_module_default = /*#__PURE__*/__webpack_require__.n(Modal_module);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/core/Modal/Modal.jsx









const Modal = (props)=>{
    const modalWindow = (0,react.useRef)(null);
    const [isRendered, setIsRendered] = (0,react.useState)(false);
    const [width, height] = (0,useWindowResize/* default */.Z)();
    const [style, setStyle] = (0,react.useState)({});
    const { className , children , showModal , modalTitle , labelledBy , describedBy , onModalClose , prevActiveElem , hideCloseIcon , closeButtonAnalytics , analyticsCustomData , needAnalyticsOnContentsLink , dataLayer , StickCloseButton , isWhiteCloseIcon =false  } = props;
    const waitingTImeForModalContentToLoad = 500;
    const triggerModalClose = (e)=>{
        (0,helper.preventBodyScroll)(false);
        onModalClose(e);
    };
    const handleKeyPress = (e)=>{
        const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusContent = modalWindow.current.querySelectorAll(focusElements);
        const firstElem = focusContent[0];
        const lastElem = focusContent[focusContent.length - 1];
        if (e.key === "Escape") {
            triggerModalClose();
        }
        if (e.key === "Tab") {
            if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === modalWindow.current)) {
                e.preventDefault();
                lastElem.focus();
            }
            if (!e.shiftKey && document.activeElement === lastElem) {
                e.preventDefault();
                firstElem.focus();
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (width < 577 || lib.isIOS && width < 992) {
            setStyle({
                style: {
                    height: height,
                    minHeight: height
                }
            });
        } else {
            setStyle({});
        }
    }, [
        width,
        height
    ]);
    (0,react.useEffect)(()=>{
        if (showModal) {
            (0,helper.removeMavenoidChat)();
            if (!isRendered) {
                setIsRendered(true);
            }
            window.addEventListener("keydown", handleKeyPress);
            window.prevActiveElement = prevActiveElem !== null && prevActiveElem !== void 0 ? prevActiveElem : document.activeElement;
            modalWindow.current.focus();
            if (needAnalyticsOnContentsLink) {
                addAnalyticsForNavigationLinks();
            }
        } else {
            (0,helper.addMavenoidChat)();
            if (!document.getElementsByClassName("show-modal-popup").length) {
                var ref;
                (ref = window.prevActiveElement) === null || ref === void 0 ? void 0 : ref.focus();
                (0,helper.setFocus)(window.keyFocusCallBack);
            }
        }
        (0,helper.preventBodyScroll)(showModal);
        return ()=>{
            window.removeEventListener("keydown", handleKeyPress);
            (0,helper.preventBodyScroll)(false);
        };
    }, [
        showModal
    ]);
    const getNavigationLinksEventInfo = function(link, linkName) {
        let clickInternalLinks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "true";
        var ref;
        const type = window.adobeDataLayer.length > 1 ? window.adobeDataLayer[1]["page"]["category"] : {};
        const eventFor = getEventFor(type);
        const internalLinkType = (type === null || type === void 0 ? void 0 : (ref = type.subCategory1) === null || ref === void 0 ? void 0 : ref.includes("my account:product registration")) ? "my account:navigation" : "".concat(eventFor, ":navigation");
        return JSON.stringify({
            clickInternalLinks,
            eventAction: "".concat(eventFor, ":modal:where do i find my product model number:").concat(linkName),
            eventMsg: "n/a",
            eventName: "".concat(eventFor, ":modal:where do i find my product model number:").concat(linkName),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: linkName,
            internalLinkPosition: (type === null || type === void 0 ? void 0 : type.subCategoryID) || "contact us",
            internalLinkType,
            internalLinkURL: link,
            internalLinkZoneName: "".concat(eventFor, ":modal:where do i find my product model number")
        });
    };
    const addAnalyticsForNavigationLinks = ()=>{
        setTimeout(()=>{
            modalWindow.current.querySelectorAll(".description p a").forEach((link)=>{
                link.classList.add("gbh-data-layer");
                const textContent = (link === null || link === void 0 ? void 0 : link.textContent) || (link.querySelector("u") ? link.querySelector("u").textContent : "");
                const clickInternalLinks = (textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase()) === "learn more" ? "true" : "false";
                const eventInfo = getNavigationLinksEventInfo(link.getAttribute("href"), textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase(), clickInternalLinks);
                link.setAttribute("data-gbh-data-layer", eventInfo);
            });
            modalWindow.current.querySelectorAll(".description h6 a").forEach((link)=>{
                if (link.textContent === "Learn More") {
                    link.classList.add("gbh-data-layer");
                    const eventInfo = getNavigationLinksEventInfo(link.getAttribute("href"), link.textContent.toLowerCase());
                    link.setAttribute("data-gbh-data-layer", eventInfo);
                }
            });
            modalWindow.current.querySelectorAll(".modal-popup-body a").forEach((link)=>{
                if (link.textContent === "Continue") {
                    link.classList.add("gbh-data-layer");
                    link.setAttribute("data-gbh-data-layer", dataLayer);
                }
            });
        }, waitingTImeForModalContentToLoad);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Modal_module_default()).modalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "modal-popup ".concat(showModal ? "show-modal-popup" : "", " ").concat(className ? className : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-popup-content",
                role: "dialog",
                "aria-modal": true,
                tabIndex: "-1",
                "aria-labelledby": labelledBy,
                "aria-describedby": describedBy,
                ref: modalWindow,
                ...style,
                children: [
                    !hideCloseIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "close-button-holder ".concat(StickCloseButton ? "stick-close-button" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "close-button".concat(closeButtonAnalytics ? " gbh-data-layer" : ""),
                            "data-gbh-data-layer": closeButtonAnalytics,
                            "data-gbh-data-layer-custom": analyticsCustomData || null,
                            onClick: triggerModalClose,
                            tabIndex: "0",
                            role: "button",
                            "aria-label": "Click here to close ".concat(modalTitle, " modal window"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: isWhiteCloseIcon ? close_white/* default */.Z === null || close_white/* default */.Z === void 0 ? void 0 : close_white/* default.src */.Z.src : modal_close/* default */.Z === null || modal_close/* default */.Z === void 0 ? void 0 : modal_close/* default.src */.Z.src,
                                "aria-hidden": true,
                                role: "presentation",
                                alt: "close"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-popup-body",
                        children: isRendered && showModal && children
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Modal_Modal = (Modal);


/***/ }),

/***/ 65131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);




const RadioButton = (param)=>{
    let { onKeydown , analyticsData , id ="" , name ="" , value =undefined , checked =undefined , onClick =()=>{}  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        role: "radio",
        onKeyDown: onKeydown,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
            radio: true
        }),
        htmlFor: id,
        "aria-checked": checked,
        tabIndex: checked ? 0 : -1,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: "radio",
                className: "radio__input " + (analyticsData ? "gbh-data-layer" : ""),
                "data-gbh-data-layer": analyticsData,
                name: name,
                id: id,
                checked: checked,
                onClick: onClick,
                onChange: onClick
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "radio__custom"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: value
            })
        ]
    });
};
RadioButton.propTypes = {
    id: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string) || (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    checked: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (RadioButton);


/***/ }),

/***/ 13875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ getSearchPDP; },
/* harmony export */   "HB": function() { return /* binding */ requestForChangePassword; },
/* harmony export */   "vP": function() { return /* binding */ getProjectionData; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64757);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _utils_ApiUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51666);




const requestForChangePassword = async (data)=>{
    try {
        return await _constants_api__WEBPACK_IMPORTED_MODULE_0__.apim.post(_constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .CHANGE_PASSWORD_ENDPOINT */ .j0, data);
    } catch (err) {
        console.error("Failed to reset password", err);
        return err.response;
    }
};
const getSearchPDP = async (slug)=>{
    try {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__.apim.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPdpEndPoint, "/").concat(slug), {
            collections: "service_parts",
            fl: "*",
            profilename: "profile_service_parts_PDP",
            q: "*:*",
            search_type: "product_detail",
            sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_3__/* .getSessionIdObjWithEpoc */ .o)()
        });
        return response;
    } catch (err) {
        return err;
    }
};
const getProjectionData = async (payload)=>{
    const { slug , skus  } = payload;
    let query = "";
    let masterQuery = "";
    if (slug) masterQuery += 'slug(en-US%3D"'.concat(slug, '") or ');
    if (skus.length > 0) {
        skus.forEach((sku, i)=>{
            query += '"'.concat(sku, '"');
            if (i + 1 !== skus.length) query += ", ";
        });
        masterQuery += "masterVariant(sku in (".concat(query, ")) or variants(sku in (").concat(query, "))");
    }
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__.apim.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .CATALOG_PROJECTION_ENDPOINT */ .E5, "?where=").concat(masterQuery));
        if (res && res.data && res.data.results) return res.data.results;
    } catch (err) {
        return err;
    }
    return [];
};


/***/ }),

/***/ 22222:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PartDiagramViewer":"partviewer_PartDiagramViewer__9cI0v"};

/***/ }),

/***/ 21531:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputFieldWrapper":"Input_inputFieldWrapper__nt6o0"};

/***/ }),

/***/ 43106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"Modal_modalWrapper__asWMh"};

/***/ })

}]);